import React, { Component, createFactory } from 'react';
import PropTypes from 'prop-types';

/* eslint-disable */
// murmurhash2 via https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
function hash(str) {
  return murmurhash2_32_gc(str, str.length).toString(36);
}

function murmurhash2_32_gc(str, seed) {
  var l = str.length,
      h = seed ^ l,
      i = 0,
      k;

  while (l >= 4) {
    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
    k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    k ^= k >>> 24;
    k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;
    l -= 4;
    ++i;
  }

  switch (l) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;

    case 2:
      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;

    case 1:
      h ^= str.charCodeAt(i) & 0xff;
      h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
  }

  h ^= h >>> 13;
  h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
  h ^= h >>> 15;
  return h >>> 0;
}

var V = function ca(W) {
  function M(e, c, d, h, a) {
    for (var l = 0, b = 0, u = 0, k = 0, q, m, f, D = 0, y = 0, r, E = r = q = 0, n = 0, J = m = 0, t = 0, K = d.length, F = K - 1, w, g = "", p = "", G = "", H = "", A; n < K;) {
      f = d.charCodeAt(n);
      n === F && 0 !== b + k + u + l && (0 !== b && (f = 47 === b ? 10 : 47), k = u = l = 0, K++, F++);

      if (0 === b + k + u + l) {
        if (n === F && (0 < m && (g = g.replace(N, "")), 0 < g.trim().length)) {
          switch (f) {
            case 32:
            case 9:
            case 59:
            case 13:
            case 10:
              break;

            default:
              g += d.charAt(n);
          }

          f = 59;
        }

        switch (f) {
          case 123:
            g = g.trim();
            q = g.charCodeAt(0);
            r = 1;

            for (t = ++n; n < K;) {
              f = d.charCodeAt(n);

              switch (f) {
                case 123:
                  r++;
                  break;

                case 125:
                  r--;
              }

              if (0 === r) break;
              n++;
            }

            f = d.substring(t, n);
            0 === q && (q = (g = g.replace(da, "").trim()).charCodeAt(0));

            switch (q) {
              case 64:
                0 < m && (g = g.replace(N, ""));
                m = g.charCodeAt(1);

                switch (m) {
                  case 100:
                  case 109:
                  case 115:
                  case 45:
                    r = c;
                    break;

                  default:
                    r = O;
                }

                f = M(c, r, f, m, a + 1);
                t = f.length;
                0 < z && (r = X(O, g, J), A = I(3, f, r, c, B, x, t, m, a, h), g = r.join(""), void 0 !== A && 0 === (t = (f = A.trim()).length) && (m = 0, f = ""));
                if (0 < t) switch (m) {
                  case 115:
                    g = g.replace(ea, fa);

                  case 100:
                  case 109:
                  case 45:
                    f = g + "{" + f + "}";
                    break;

                  case 107:
                    g = g.replace(ha, "$1 $2");
                    f = g + "{" + f + "}";
                    f = 1 === v || 2 === v && L("@" + f, 3) ? "@-webkit-" + f + "@" + f : "@" + f;
                    break;

                  default:
                    f = g + f, 112 === h && (f = (p += f, ""));
                } else f = "";
                break;

              default:
                f = M(c, X(c, g, J), f, h, a + 1);
            }

            G += f;
            r = J = m = E = q = 0;
            g = "";
            f = d.charCodeAt(++n);
            break;

          case 125:
          case 59:
            g = (0 < m ? g.replace(N, "") : g).trim();
            if (1 < (t = g.length)) switch (0 === E && (q = g.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (g = g.replace(" ", ":")).length), 0 < z && void 0 !== (A = I(1, g, c, e, B, x, p.length, h, a, h)) && 0 === (t = (g = A.trim()).length) && (g = "\x00\x00"), q = g.charCodeAt(0), m = g.charCodeAt(1), q + m) {
              case 0:
                break;

              case 169:
              case 163:
                H += g + d.charAt(n);
                break;

              default:
                58 !== g.charCodeAt(t - 1) && (p += P(g, q, m, g.charCodeAt(2)));
            }
            J = m = E = q = 0;
            g = "";
            f = d.charCodeAt(++n);
        }
      }

      switch (f) {
        case 13:
        case 10:
          47 === b ? b = 0 : 0 === 1 + q && (m = 1, g += "\x00");
          0 < z * Y && I(0, g, c, e, B, x, p.length, h, a, h);
          x = 1;
          B++;
          break;

        case 59:
        case 125:
          if (0 === b + k + u + l) {
            x++;
            break;
          }

        default:
          x++;
          w = d.charAt(n);

          switch (f) {
            case 9:
            case 32:
              if (0 === k + l + b) switch (D) {
                case 44:
                case 58:
                case 9:
                case 32:
                  w = "";
                  break;

                default:
                  32 !== f && (w = " ");
              }
              break;

            case 0:
              w = "\\0";
              break;

            case 12:
              w = "\\f";
              break;

            case 11:
              w = "\\v";
              break;

            case 38:
              0 === k + b + l && (m = J = 1, w = "\f" + w);
              break;

            case 108:
              if (0 === k + b + l + C && 0 < E) switch (n - E) {
                case 2:
                  112 === D && 58 === d.charCodeAt(n - 3) && (C = D);

                case 8:
                  111 === y && (C = y);
              }
              break;

            case 58:
              0 === k + b + l && (E = n);
              break;

            case 44:
              0 === b + u + k + l && (m = 1, w += "\r");
              break;

            case 34:
              0 === b && (k = k === f ? 0 : 0 === k ? f : k);
              break;

            case 39:
              0 === b && (k = k === f ? 0 : 0 === k ? f : k);
              break;

            case 91:
              0 === k + b + u && l++;
              break;

            case 93:
              0 === k + b + u && l--;
              break;

            case 41:
              0 === k + b + l && u--;
              break;

            case 40:
              if (0 === k + b + l) {
                if (0 === q) switch (2 * D + 3 * y) {
                  case 533:
                    break;

                  default:
                    q = 1;
                }
                u++;
              }

              break;

            case 64:
              0 === b + u + k + l + E + r && (r = 1);
              break;

            case 42:
            case 47:
              if (!(0 < k + l + u)) switch (b) {
                case 0:
                  switch (2 * f + 3 * d.charCodeAt(n + 1)) {
                    case 235:
                      b = 47;
                      break;

                    case 220:
                      t = n, b = 42;
                  }

                  break;

                case 42:
                  47 === f && 42 === D && (33 === d.charCodeAt(t + 2) && (p += d.substring(t, n + 1)), w = "", b = 0);
              }
          }

          0 === b && (g += w);
      }

      y = D;
      D = f;
      n++;
    }

    t = p.length;

    if (0 < t) {
      r = c;
      if (0 < z && (A = I(2, p, r, e, B, x, t, h, a, h), void 0 !== A && 0 === (p = A).length)) return H + p + G;
      p = r.join(",") + "{" + p + "}";

      if (0 !== v * C) {
        2 !== v || L(p, 2) || (C = 0);

        switch (C) {
          case 111:
            p = p.replace(ia, ":-moz-$1") + p;
            break;

          case 112:
            p = p.replace(Q, "::-webkit-input-$1") + p.replace(Q, "::-moz-$1") + p.replace(Q, ":-ms-input-$1") + p;
        }

        C = 0;
      }
    }

    return H + p + G;
  }

  function X(e, c, d) {
    var h = c.trim().split(ja);
    c = h;
    var a = h.length,
        l = e.length;

    switch (l) {
      case 0:
      case 1:
        var b = 0;

        for (e = 0 === l ? "" : e[0] + " "; b < a; ++b) {
          c[b] = Z(e, c[b], d, l).trim();
        }

        break;

      default:
        var u = b = 0;

        for (c = []; b < a; ++b) {
          for (var k = 0; k < l; ++k) {
            c[u++] = Z(e[k] + " ", h[b], d, l).trim();
          }
        }

    }

    return c;
  }

  function Z(e, c, d) {
    var h = c.charCodeAt(0);
    33 > h && (h = (c = c.trim()).charCodeAt(0));

    switch (h) {
      case 38:
        return c.replace(F, "$1" + e.trim());

      case 58:
        switch (c.charCodeAt(1)) {
          case 103:
            break;

          default:
            return e.trim() + c.replace(F, "$1" + e.trim());
        }

      default:
        if (0 < 1 * d && 0 < c.indexOf("\f")) return c.replace(F, (58 === e.charCodeAt(0) ? "" : "$1") + e.trim());
    }

    return e + c;
  }

  function P(e, c, d, h) {
    var a = e + ";",
        l = 2 * c + 3 * d + 4 * h;

    if (944 === l) {
      e = a.indexOf(":", 9) + 1;
      var b = a.substring(e, a.length - 1).trim();
      b = a.substring(0, e).trim() + b + ";";
      return 1 === v || 2 === v && L(b, 1) ? "-webkit-" + b + b : b;
    }

    if (0 === v || 2 === v && !L(a, 1)) return a;

    switch (l) {
      case 1015:
        return 97 === a.charCodeAt(10) ? "-webkit-" + a + a : a;

      case 951:
        return 116 === a.charCodeAt(3) ? "-webkit-" + a + a : a;

      case 963:
        return 110 === a.charCodeAt(5) ? "-webkit-" + a + a : a;

      case 1009:
        if (100 !== a.charCodeAt(4)) break;

      case 969:
      case 942:
        return "-webkit-" + a + a;

      case 978:
        return "-webkit-" + a + "-moz-" + a + a;

      case 1019:
      case 983:
        return "-webkit-" + a + "-moz-" + a + "-ms-" + a + a;

      case 883:
        return 45 === a.charCodeAt(8) ? "-webkit-" + a + a : a;

      case 932:
        if (45 === a.charCodeAt(4)) switch (a.charCodeAt(5)) {
          case 103:
            return "-webkit-box-" + a.replace("-grow", "") + "-webkit-" + a + "-ms-" + a.replace("grow", "positive") + a;

          case 115:
            return "-webkit-" + a + "-ms-" + a.replace("shrink", "negative") + a;

          case 98:
            return "-webkit-" + a + "-ms-" + a.replace("basis", "preferred-size") + a;
        }
        return "-webkit-" + a + "-ms-" + a + a;

      case 964:
        return "-webkit-" + a + "-ms-flex-" + a + a;

      case 1023:
        if (99 !== a.charCodeAt(8)) break;
        b = a.substring(a.indexOf(":", 15)).replace("flex-", "").replace("space-between", "justify");
        return "-webkit-box-pack" + b + "-webkit-" + a + "-ms-flex-pack" + b + a;

      case 1005:
        return ka.test(a) ? a.replace(aa, ":-webkit-") + a.replace(aa, ":-moz-") + a : a;

      case 1e3:
        b = a.substring(13).trim();
        c = b.indexOf("-") + 1;

        switch (b.charCodeAt(0) + b.charCodeAt(c)) {
          case 226:
            b = a.replace(G, "tb");
            break;

          case 232:
            b = a.replace(G, "tb-rl");
            break;

          case 220:
            b = a.replace(G, "lr");
            break;

          default:
            return a;
        }

        return "-webkit-" + a + "-ms-" + b + a;

      case 1017:
        if (-1 === a.indexOf("sticky", 9)) break;

      case 975:
        c = (a = e).length - 10;
        b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(e.indexOf(":", 7) + 1).trim();

        switch (l = b.charCodeAt(0) + (b.charCodeAt(7) | 0)) {
          case 203:
            if (111 > b.charCodeAt(8)) break;

          case 115:
            a = a.replace(b, "-webkit-" + b) + ";" + a;
            break;

          case 207:
          case 102:
            a = a.replace(b, "-webkit-" + (102 < l ? "inline-" : "") + "box") + ";" + a.replace(b, "-webkit-" + b) + ";" + a.replace(b, "-ms-" + b + "box") + ";" + a;
        }

        return a + ";";

      case 938:
        if (45 === a.charCodeAt(5)) switch (a.charCodeAt(6)) {
          case 105:
            return b = a.replace("-items", ""), "-webkit-" + a + "-webkit-box-" + b + "-ms-flex-" + b + a;

          case 115:
            return "-webkit-" + a + "-ms-flex-item-" + a.replace(ba, "") + a;

          default:
            return "-webkit-" + a + "-ms-flex-line-pack" + a.replace("align-content", "").replace(ba, "") + a;
        }
        break;

      case 973:
      case 989:
        if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;

      case 931:
      case 953:
        if (!0 === la.test(e)) return 115 === (b = e.substring(e.indexOf(":") + 1)).charCodeAt(0) ? P(e.replace("stretch", "fill-available"), c, d, h).replace(":fill-available", ":stretch") : a.replace(b, "-webkit-" + b) + a.replace(b, "-moz-" + b.replace("fill-", "")) + a;
        break;

      case 962:
        if (a = "-webkit-" + a + (102 === a.charCodeAt(5) ? "-ms-" + a : "") + a, 211 === d + h && 105 === a.charCodeAt(13) && 0 < a.indexOf("transform", 10)) return a.substring(0, a.indexOf(";", 27) + 1).replace(ma, "$1-webkit-$2") + a;
    }

    return a;
  }

  function L(e, c) {
    var d = e.indexOf(1 === c ? ":" : "{"),
        h = e.substring(0, 3 !== c ? d : 10);
    d = e.substring(d + 1, e.length - 1);
    return H(2 !== c ? h : h.replace(na, "$1"), d, c);
  }

  function fa(e, c) {
    var d = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
    return d !== c + ";" ? d.replace(oa, " or ($1)").substring(4) : "(" + c + ")";
  }

  function I(e, c, d, h, a, l, b, u, k, q) {
    for (var m = 0, f = c, v; m < z; ++m) {
      switch (v = R[m].call(y, e, f, d, h, a, l, b, u, k, q)) {
        case void 0:
        case !1:
        case !0:
        case null:
          break;

        default:
          f = v;
      }
    }

    switch (f) {
      case void 0:
      case !1:
      case !0:
      case null:
      case c:
        break;

      default:
        return f;
    }
  }

  function S(e) {
    switch (e) {
      case void 0:
      case null:
        z = R.length = 0;
        break;

      default:
        switch (e.constructor) {
          case Array:
            for (var c = 0, d = e.length; c < d; ++c) {
              S(e[c]);
            }

            break;

          case Function:
            R[z++] = e;
            break;

          case Boolean:
            Y = !!e | 0;
        }

    }

    return S;
  }

  function T(e) {
    for (var c in e) {
      var d = e[c];

      switch (c) {
        case "prefix":
          H = null, d ? "function" !== typeof d ? v = 1 : (v = 2, H = d) : v = 0;
      }
    }

    return T;
  }

  function y(e, c) {
    if (void 0 !== this && this.constructor === y) return ca(e);
    var d = e;
    33 > d.charCodeAt(0) && (d = d.trim());
    U = d;
    d = [U];

    if (0 < z) {
      var h = I(-1, c, d, d, B, x, 0, 0, 0, 0);
      void 0 !== h && "string" === typeof h && (c = h);
    }

    var a = M(O, d, c, 0, 0);
    0 < z && (h = I(-2, a, d, d, B, x, a.length, 0, 0, 0), void 0 !== h && (a = h));
    U = "";
    C = 0;
    x = B = 1;
    return a;
  }

  var da = /^\0+/g,
      N = /[\0\r\f]/g,
      aa = /: */g,
      ka = /zoo|gra/,
      ma = /([,: ])(transform)/g,
      ja = /,\r+?/g,
      F = /([\t\r\n ])*\f?&/g,
      ha = /@(k\w+)\s*(\S*)\s*/,
      Q = /::(place)/g,
      ia = /:(read-only)/g,
      G = /[svh]\w+-[tblr]{2}/,
      ea = /\(\s*(.*)\s*\)/g,
      oa = /([\s\S]*?);/g,
      ba = /-self|flex-/g,
      na = /[^]*?(:[rp][el]a[\w-]+)[^]*/,
      la = /stretch|:\s*\w+\-(?:conte|avail)/,
      x = 1,
      B = 1,
      C = 0,
      v = 1,
      O = [],
      R = [],
      z = 0,
      H = null,
      Y = 0,
      U = "";
  y.use = S;
  y.set = T;
  void 0 !== W && T(W);
  return y;
};

var commonjsGlobal = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};



function unwrapExports (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var stylisRuleSheet = createCommonjsModule(function (module, exports) {
(function (factory) {
	module['exports'] = factory();
}(function () {

	return function (insertRule) {
		var delimiter = '/*|*/';
		var needle = delimiter+'}';

		function toSheet (block) {
			if (block)
				try {
					insertRule(block + '}');
				} catch (e) {}
		}

		return function ruleSheet (context, content, selectors, parents, line, column, length, ns, depth, at) {
			switch (context) {
				// property
				case 1:
					// @import
					if (depth === 0 && content.charCodeAt(0) === 64)
						return insertRule(content+';'), ''
					break
				// selector
				case 2:
					if (ns === 0)
						return content + delimiter
					break
				// at-rule
				case 3:
					switch (ns) {
						// @font-face, @page
						case 102:
						case 112:
							return insertRule(selectors[0]+content), ''
						default:
							return content + (at === 0 ? delimiter : '')
					}
				case -2:
					content.split(needle).forEach(toSheet);
			}
		}
	}
}));
});

function memoize(fn) {
  var cache = {};
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

var index = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

var hyphenateRegex = /[A-Z]|^ms/g;
var processStyleName = memoize(function (styleName) {
  return styleName.replace(hyphenateRegex, '-$&').toLowerCase();
});
var processStyleValue = function processStyleValue(key, value) {
  if (value == null || typeof value === 'boolean') {
    return '';
  }

  if (index[key] !== 1 && key.charCodeAt(1) !== 45 && // custom properties
  !isNaN(value) && value !== 0) {
    return value + 'px';
  }

  return value;
};
var classnames = function classnames(args) {
  var len = args.length;
  var i = 0;
  var cls = '';

  for (; i < len; i++) {
    var arg = args[i];
    if (arg == null) continue;
    var toAdd = void 0;

    switch (typeof arg) {
      case 'boolean':
        break;

      case 'function':
        toAdd = classnames([arg()]);
        break;

      case 'object':
        {
          if (Array.isArray(arg)) {
            toAdd = classnames(arg);
          } else {
            toAdd = '';

            for (var k in arg) {
              if (arg[k] && k) {
                toAdd && (toAdd += ' ');
                toAdd += k;
              }
            }
          }

          break;
        }

      default:
        {
          toAdd = arg;
        }
    }

    if (toAdd) {
      cls && (cls += ' ');
      cls += toAdd;
    }
  }

  return cls;
};
var isBrowser = typeof document !== 'undefined';

/*

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance
- 'polyfills' on server side

// usage

import StyleSheet from 'glamor/lib/sheet'
let styleSheet = new StyleSheet()

styleSheet.inject()
- 'injects' the stylesheet into the page (or into memory if on server)

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/
// $FlowFixMe
function sheetForTag(tag) {
  if (tag.sheet) {
    // $FlowFixMe
    return tag.sheet;
  } // this weirdness brought to you by firefox


  for (var i = 0; i < document.styleSheets.length; i++) {
    if (document.styleSheets[i].ownerNode === tag) {
      // $FlowFixMe
      return document.styleSheets[i];
    }
  }
}

function makeStyleTag(opts) {
  var tag = document.createElement('style');
  tag.setAttribute('data-emotion', opts.key || '');

  if (opts.nonce !== undefined) {
    tag.setAttribute('nonce', opts.nonce);
  }

  tag.appendChild(document.createTextNode('')) // $FlowFixMe
  ;
  (opts.container !== undefined ? opts.container : document.head).appendChild(tag);
  return tag;
}

function _StyleSheet(options) {
  this.isSpeedy = process.env.NODE_ENV === 'production'; // the big drawback here is that the css won't be editable in devtools

  this.tags = [];
  this.ctr = 0;
  this.opts = options;
}

function _inject() {
  if (this.injected) {
    throw new Error('already injected!');
  }

  this.tags[0] = makeStyleTag(this.opts);
  this.injected = true;
}

function _speedy(bool) {
  if (this.ctr !== 0) {
    // cannot change speedy mode after inserting any rule to sheet. Either call speedy(${bool}) earlier in your app, or call flush() before speedy(${bool})
    throw new Error("cannot change speedy now");
  }

  this.isSpeedy = !!bool;
}

function _insert(rule, sourceMap) {
  // this is the ultrafast version, works across browsers
  if (this.isSpeedy) {
    var tag = this.tags[this.tags.length - 1];
    var sheet = sheetForTag(tag);

    try {
      sheet.insertRule(rule, sheet.cssRules.length);
    } catch (e) {
      if (process.env.NODE_ENV !== 'production') {
        console.warn('illegal rule', rule); // eslint-disable-line no-console
      }
    }
  } else {
    var _tag = makeStyleTag(this.opts);

    this.tags.push(_tag);

    _tag.appendChild(document.createTextNode(rule + (sourceMap || '')));
  }

  this.ctr++;

  if (this.ctr % 65000 === 0) {
    this.tags.push(makeStyleTag(this.opts));
  }
}

function _ref(tag) {
  return tag.parentNode.removeChild(tag);
}

function _flush() {
  // $FlowFixMe
  this.tags.forEach(_ref);
  this.tags = [];
  this.ctr = 0; // todo - look for remnants in document.styleSheets

  this.injected = false;
}

var StyleSheet =
/*#__PURE__*/
function () {
  var _proto = _StyleSheet.prototype;
  _proto.inject = _inject;
  _proto.speedy = _speedy;
  _proto.insert = _insert;
  _proto.flush = _flush;
  return _StyleSheet;
}();

function createEmotion(context, options) {
  if (context.__SECRET_EMOTION__ !== undefined) {
    return context.__SECRET_EMOTION__;
  }

  if (options === undefined) options = {};
  var key = options.key || 'css';

  if (process.env.NODE_ENV !== 'production') {
    if (/[^a-z-]/.test(key)) {
      throw new Error("Emotion key must only contain lower case alphabetical characters and - but \"" + key + "\" was passed");
    }
  }

  var current;

  function insertRule(rule) {
    current += rule;

    if (isBrowser) {
      sheet.insert(rule, currentSourceMap);
    }
  }

  var insertionPlugin = stylisRuleSheet(insertRule);
  var stylisOptions;

  if (options.prefix !== undefined) {
    stylisOptions = {
      prefix: options.prefix
    };
  }

  var caches = {
    registered: {},
    inserted: {},
    nonce: options.nonce,
    key: key
  };
  var sheet = new StyleSheet(options);

  if (isBrowser) {
    // 🚀
    sheet.inject();
  }

  var stylis = new V(stylisOptions);
  stylis.use(options.stylisPlugins)(insertionPlugin);
  var currentSourceMap = '';

  function handleInterpolation(interpolation, couldBeSelectorInterpolation) {
    if (interpolation == null) {
      return '';
    }

    switch (typeof interpolation) {
      case 'boolean':
        return '';

      case 'function':
        if (interpolation.__emotion_styles !== undefined) {
          var selector = interpolation.toString();

          if (selector === 'NO_COMPONENT_SELECTOR' && process.env.NODE_ENV !== 'production') {
            throw new Error('Component selectors can only be used in conjunction with babel-plugin-emotion.');
          }

          return selector;
        }

        return handleInterpolation.call(this, this === undefined ? interpolation() : // $FlowFixMe
        interpolation(this.mergedProps, this.context), couldBeSelectorInterpolation);

      case 'object':
        return createStringFromObject.call(this, interpolation);

      default:
        var cached = caches.registered[interpolation];
        return couldBeSelectorInterpolation === false && cached !== undefined ? cached : interpolation;
    }
  }

  var objectToStringCache = new WeakMap();

  function createStringFromObject(obj) {
    if (objectToStringCache.has(obj)) {
      // $FlowFixMe
      return objectToStringCache.get(obj);
    }

    var string = '';

    function _ref(interpolation) {
      string += handleInterpolation.call(this, interpolation, false);
    }

    function _ref2(key) {
      if (typeof obj[key] !== 'object') {
        if (caches.registered[obj[key]] !== undefined) {
          string += key + "{" + caches.registered[obj[key]] + "}";
        } else {
          string += processStyleName(key) + ":" + processStyleValue(key, obj[key]) + ";";
        }
      } else {
        if (key === 'NO_COMPONENT_SELECTOR' && process.env.NODE_ENV !== 'production') {
          throw new Error('Component selectors can only be used in conjunction with babel-plugin-emotion.');
        }

        string += key + "{" + handleInterpolation.call(this, obj[key], false) + "}";
      }
    }

    if (Array.isArray(obj)) {
      obj.forEach(_ref, this);
    } else {
      Object.keys(obj).forEach(_ref2, this);
    }

    objectToStringCache.set(obj, string);
    return string;
  }

  var name;
  var stylesWithLabel;
  var labelPattern = /label:\s*([^\s;\n{]+)\s*;/g;

  var createStyles = function createStyles(strings) {
    var stringMode = true;
    var styles = '';
    var identifierName = '';

    if (strings == null || strings.raw === undefined) {
      stringMode = false;
      styles += handleInterpolation.call(this, strings, false);
    } else {
      styles += strings[0];
    }

    for (var _len = arguments.length, interpolations = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      interpolations[_key - 1] = arguments[_key];
    }

    interpolations.forEach(function (interpolation, i) {
      styles += handleInterpolation.call(this, interpolation, styles.charCodeAt(styles.length - 1) === 46 // .
      );

      if (stringMode === true && strings[i + 1] !== undefined) {
        styles += strings[i + 1];
      }
    }, this);
    stylesWithLabel = styles;
    styles = styles.replace(labelPattern, function (match, p1) {
      identifierName += "-" + p1;
      return '';
    });
    name = hash(styles + identifierName) + identifierName;
    return styles;
  };

  if (process.env.NODE_ENV !== 'production') {
    var sourceMapRegEx = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//;
    var oldStylis = stylis;

    stylis = function stylis(selector, styles) {
      var result = sourceMapRegEx.exec(styles);
      currentSourceMap = result ? result[0] : '';
      oldStylis(selector, styles);
      currentSourceMap = '';
    };
  }

  function insert(scope, styles) {
    if (caches.inserted[name] === undefined) {
      current = '';
      stylis(scope, styles);
      caches.inserted[name] = current;
    }
  }

  var css = function css() {
    var styles = createStyles.apply(this, arguments);
    var selector = key + "-" + name;

    if (caches.registered[selector] === undefined) {
      caches.registered[selector] = stylesWithLabel;
    }

    insert("." + selector, styles);
    return selector;
  };

  var keyframes = function keyframes() {
    var styles = createStyles.apply(this, arguments);
    var animation = "animation-" + name;
    insert('', "@keyframes " + animation + "{" + styles + "}");
    return animation;
  };

  var injectGlobal = function injectGlobal() {
    var styles = createStyles.apply(this, arguments);
    insert('', styles);
  };

  function getRegisteredStyles(registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function (className) {
      if (caches.registered[className] !== undefined) {
        registeredStyles.push(className);
      } else {
        rawClassName += className + " ";
      }
    });
    return rawClassName;
  }

  function merge(className, sourceMap) {
    var registeredStyles = [];
    var rawClassName = getRegisteredStyles(registeredStyles, className);

    if (registeredStyles.length < 2) {
      return className;
    }

    return rawClassName + css(registeredStyles, sourceMap);
  }

  function cx() {
    for (var _len2 = arguments.length, classNames = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      classNames[_key2] = arguments[_key2];
    }

    return merge(classnames(classNames));
  }

  function hydrateSingleId(id) {
    caches.inserted[id] = true;
  }

  function hydrate(ids) {
    ids.forEach(hydrateSingleId);
  }

  function flush() {
    if (isBrowser) {
      sheet.flush();
      sheet.inject();
    }

    caches.inserted = {};
    caches.registered = {};
  }

  function _ref3(node) {
    // $FlowFixMe
    sheet.tags[0].parentNode.insertBefore(node, sheet.tags[0]); // $FlowFixMe

    node.getAttribute("data-emotion-" + key).split(' ').forEach(hydrateSingleId);
  }

  if (isBrowser) {
    var chunks = document.querySelectorAll("[data-emotion-" + key + "]");
    Array.prototype.forEach.call(chunks, _ref3);
  }

  var emotion = {
    flush: flush,
    hydrate: hydrate,
    cx: cx,
    merge: merge,
    getRegisteredStyles: getRegisteredStyles,
    injectGlobal: injectGlobal,
    keyframes: keyframes,
    css: css,
    sheet: sheet,
    caches: caches
  };
  context.__SECRET_EMOTION__ = emotion;
  return emotion;
}

var context = typeof global !== 'undefined' ? global : {};

var _createEmotion = createEmotion(context);
var flush = _createEmotion.flush;
var hydrate = _createEmotion.hydrate;
var cx = _createEmotion.cx;
var merge = _createEmotion.merge;
var getRegisteredStyles = _createEmotion.getRegisteredStyles;
var injectGlobal = _createEmotion.injectGlobal;
var keyframes = _createEmotion.keyframes;
var css = _createEmotion.css;
var sheet = _createEmotion.sheet;
var caches = _createEmotion.caches;





var emotion = Object.freeze({
	flush: flush,
	hydrate: hydrate,
	cx: cx,
	merge: merge,
	getRegisteredStyles: getRegisteredStyles,
	injectGlobal: injectGlobal,
	keyframes: keyframes,
	css: css,
	sheet: sheet,
	caches: caches
});

var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|accept|acceptCharset|accessKey|action|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|default|defer|dir|disabled|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|itemProp|itemScope|itemType|itemID|itemRef|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan)|(on[A-Z].*)|((data|aria)-.*))$/;
var index$1 = memoize(RegExp.prototype.test.bind(reactPropsRegex));

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

var channel = '__EMOTION_THEMING__';

// https://github.com/styled-components/styled-components/blob/e05b3fe247e9d956bcde786cec376e32afb85bca/src/utils/create-broadcast.js

var _contextTypes;

var contextTypes = (_contextTypes = {}, _contextTypes[channel] = PropTypes.object, _contextTypes);

function setTheme(theme) {
  this.setState({
    theme: theme
  });
}
var testPickPropsOnStringTag = index$1;
var testPickPropsOnComponent = function testPickPropsOnComponent(key) {
  return key !== 'theme' && key !== 'innerRef';
};
var testAlwaysTrue = function testAlwaysTrue() {
  return true;
};
var pickAssign = function pickAssign(testFn, target) {
  var i = 2;
  var length = arguments.length;

  for (; i < length; i++) {
    var source = arguments[i];

    var _key = void 0;

    for (_key in source) {
      if (testFn(_key)) {
        target[_key] = source[_key];
      }
    }
  }

  return target;
};

function _componentWillMount() {
  if (this.context[channel] !== undefined) {
    this.unsubscribe = this.context[channel].subscribe(setTheme.bind(this));
  }
}

function _componentWillUnmount() {
  if (this.unsubscribe !== undefined) {
    this.context[channel].unsubscribe(this.unsubscribe);
  }
}

function _get(target, property) {
  switch (property) {
    // react-hot-loader tries to access this stuff
    case '__proto__':
    case 'name':
    case 'prototype':
    case 'displayName':
      {
        return target[property];
      }

    default:
      {
        throw new Error("You're trying to use the styled shorthand without babel-plugin-emotion." + ("\nPlease install and setup babel-plugin-emotion or use the function call syntax(`styled('" + property + "')` instead of `styled." + property + "`)"));
      }
  }
}

function createEmotionStyled(emotion, view) {
  var _createStyled = function createStyled(tag, options) {
    if (process.env.NODE_ENV !== 'production') {
      if (tag === undefined) {
        throw new Error('You are trying to create a styled element with an undefined component.\nYou may have forgotten to import it.');
      }
    }

    var staticClassName;
    var identifierName;
    var stableClassName;
    var shouldForwardProp;

    if (options !== undefined) {
      staticClassName = options.e;
      identifierName = options.label;
      stableClassName = options.target;
      shouldForwardProp = options.shouldForwardProp;
    }

    var isReal = tag.__emotion_real === tag;
    var baseTag = staticClassName === undefined ? isReal && tag.__emotion_base || tag : tag;

    if (typeof shouldForwardProp !== 'function') {
      shouldForwardProp = typeof baseTag === 'string' && baseTag.charAt(0) === baseTag.charAt(0).toLowerCase() ? testPickPropsOnStringTag : testPickPropsOnComponent;
    }

    function _value() {
      if (process.env.NODE_ENV !== 'production' && stableClassName === undefined) {
        return 'NO_COMPONENT_SELECTOR';
      } // $FlowFixMe


      return "." + stableClassName;
    }

    return function () {
      var args = arguments;
      var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];

      if (identifierName !== undefined) {
        styles.push("label:" + identifierName + ";");
      }

      if (staticClassName === undefined) {
        if (args[0] == null || args[0].raw === undefined) {
          styles.push.apply(styles, args);
        } else {
          styles.push(args[0][0]);
          var len = args.length;
          var i = 1;

          for (; i < len; i++) {
            styles.push(args[i], args[0][i]);
          }
        }
      }

      function _render() {
        var props = this.props,
            state = this.state;
        this.mergedProps = pickAssign(testAlwaysTrue, {}, props, {
          theme: state !== null && state.theme || props.theme || {}
        });
        var className = '';
        var classInterpolations = [];

        if (props.className) {
          if (staticClassName === undefined) {
            className += emotion.getRegisteredStyles(classInterpolations, props.className);
          } else {
            className += props.className + " ";
          }
        }

        if (staticClassName === undefined) {
          className += emotion.css.apply(this, styles.concat(classInterpolations));
        } else {
          className += staticClassName;
        }

        if (stableClassName !== undefined) {
          className += " " + stableClassName;
        }

        return view.createElement(baseTag, // $FlowFixMe
        pickAssign(shouldForwardProp, {}, props, {
          className: className,
          ref: props.innerRef
        }));
      }

      var Styled =
      /*#__PURE__*/
      function (_view$Component) {
        _inheritsLoose(Styled, _view$Component);

        function Styled() {
          return _view$Component.apply(this, arguments) || this;
        }

        var _proto = Styled.prototype;
        _proto.componentWillMount = _componentWillMount;
        _proto.componentWillUnmount = _componentWillUnmount;
        _proto.render = _render;
        return Styled;
      }(view.Component);

      Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
      Styled.contextTypes = contextTypes;
      Styled.__emotion_styles = styles;
      Styled.__emotion_base = baseTag;
      Styled.__emotion_real = Styled;
      Object.defineProperty(Styled, 'toString', {
        enumerable: false,
        value: _value
      });

      Styled.withComponent = function (nextTag, nextOptions) {
        return _createStyled(nextTag, nextOptions !== undefined ? // $FlowFixMe
        pickAssign(testAlwaysTrue, {}, options, nextOptions) : options).apply(void 0, styles);
      };

      return Styled;
    };
  };

  if (process.env.NODE_ENV !== 'production' && typeof Proxy !== 'undefined') {
    _createStyled = new Proxy(_createStyled, {
      get: _get
    });
  }

  return _createStyled;
}

var index$2 = createEmotionStyled(emotion, React);

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

/*eslint-disable no-self-compare */

var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

var shallowEqual_1 = shallowEqual;

var hoistNonReactStatics = createCommonjsModule(function (module, exports) {
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
(function (global, factory) {
    module.exports = factory();
}(commonjsGlobal, (function () {
    var REACT_STATICS = {
        childContextTypes: true,
        contextTypes: true,
        defaultProps: true,
        displayName: true,
        getDefaultProps: true,
        getDerivedStateFromProps: true,
        mixins: true,
        propTypes: true,
        type: true
    };
    
    var KNOWN_STATICS = {
        name: true,
        length: true,
        prototype: true,
        caller: true,
        callee: true,
        arguments: true,
        arity: true
    };
    
    var defineProperty = Object.defineProperty;
    var getOwnPropertyNames = Object.getOwnPropertyNames;
    var getOwnPropertySymbols = Object.getOwnPropertySymbols;
    var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
    var getPrototypeOf = Object.getPrototypeOf;
    var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
    
    return function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
        if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
            
            if (objectPrototype) {
                var inheritedComponent = getPrototypeOf(sourceComponent);
                if (inheritedComponent && inheritedComponent !== objectPrototype) {
                    hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
                }
            }
            
            var keys = getOwnPropertyNames(sourceComponent);
            
            if (getOwnPropertySymbols) {
                keys = keys.concat(getOwnPropertySymbols(sourceComponent));
            }
            
            for (var i = 0; i < keys.length; ++i) {
                var key = keys[i];
                if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                    var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                    try { // Avoid failures from read-only properties
                        defineProperty(targetComponent, key, descriptor);
                    } catch (e) {}
                }
            }
            
            return targetComponent;
        }
        
        return targetComponent;
    };
})));
});

var lib = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", {
  value: true
});
var createChangeEmitter = exports.createChangeEmitter = function createChangeEmitter() {
  var currentListeners = [];
  var nextListeners = currentListeners;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }

  function listen(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected listener to be a function.');
    }

    var isSubscribed = true;

    ensureCanMutateNextListeners();
    nextListeners.push(listener);

    return function () {
      if (!isSubscribed) {
        return;
      }

      isSubscribed = false;

      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }

  function emit() {
    currentListeners = nextListeners;
    var listeners = currentListeners;
    for (var i = 0; i < listeners.length; i++) {
      listeners[i].apply(listeners, arguments);
    }
  }

  return {
    listen: listen,
    emit: emit
  };
};
});

unwrapExports(lib);
var lib_1 = lib.createChangeEmitter;

function symbolObservablePonyfill(root) {
	var result;
	var Symbol = root.Symbol;

	if (typeof Symbol === 'function') {
		if (Symbol.observable) {
			result = Symbol.observable;
		} else {
			result = Symbol('observable');
			Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
}

/* global window */
var root;

if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (typeof module !== 'undefined') {
  root = module;
} else {
  root = Function('return this')();
}

var result = symbolObservablePonyfill(root);

var setStatic = function setStatic(key, value) {
  return function (BaseComponent) {
    /* eslint-disable no-param-reassign */
    BaseComponent[key] = value;
    /* eslint-enable no-param-reassign */
    return BaseComponent;
  };
};

var setDisplayName = function setDisplayName(displayName) {
  return setStatic('displayName', displayName);
};

var getDisplayName = function getDisplayName(Component$$1) {
  if (typeof Component$$1 === 'string') {
    return Component$$1;
  }

  if (!Component$$1) {
    return undefined;
  }

  return Component$$1.displayName || Component$$1.name || 'Component';
};

var wrapDisplayName = function wrapDisplayName(BaseComponent, hocName) {
  return hocName + '(' + getDisplayName(BaseComponent) + ')';
};

var mapProps = function mapProps(propsMapper) {
  return function (BaseComponent) {
    var factory = createFactory(BaseComponent);
    var MapProps = function MapProps(props) {
      return factory(propsMapper(props));
    };
    if (process.env.NODE_ENV !== 'production') {
      return setDisplayName(wrapDisplayName(BaseComponent, 'mapProps'))(MapProps);
    }
    return MapProps;
  };
};

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};









var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};



var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};









var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var withProps = function withProps(input) {
  var hoc = mapProps(function (props) {
    return _extends({}, props, typeof input === 'function' ? input(props) : input);
  });
  if (process.env.NODE_ENV !== 'production') {
    return function (BaseComponent) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withProps'))(hoc(BaseComponent));
    };
  }
  return hoc;
};

var defaultProps = function defaultProps(props) {
  return function (BaseComponent) {
    var factory = createFactory(BaseComponent);
    var DefaultProps = function DefaultProps(ownerProps) {
      return factory(ownerProps);
    };
    DefaultProps.defaultProps = props;
    if (process.env.NODE_ENV !== 'production') {
      return setDisplayName(wrapDisplayName(BaseComponent, 'defaultProps'))(DefaultProps);
    }
    return DefaultProps;
  };
};

var Nothing = function (_Component) {
  inherits(Nothing, _Component);

  function Nothing() {
    classCallCheck(this, Nothing);
    return possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  Nothing.prototype.render = function render() {
    return null;
  };

  return Nothing;
}(Component);

var shouldUpdate = function shouldUpdate(test) {
  return function (BaseComponent) {
    var factory = createFactory(BaseComponent);

    var ShouldUpdate = function (_Component) {
      inherits(ShouldUpdate, _Component);

      function ShouldUpdate() {
        classCallCheck(this, ShouldUpdate);
        return possibleConstructorReturn(this, _Component.apply(this, arguments));
      }

      ShouldUpdate.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
        return test(this.props, nextProps);
      };

      ShouldUpdate.prototype.render = function render() {
        return factory(this.props);
      };

      return ShouldUpdate;
    }(Component);

    if (process.env.NODE_ENV !== 'production') {
      return setDisplayName(wrapDisplayName(BaseComponent, 'shouldUpdate'))(ShouldUpdate);
    }
    return ShouldUpdate;
  };
};

var pure = function pure(BaseComponent) {
  var hoc = shouldUpdate(function (props, nextProps) {
    return !shallowEqual_1(props, nextProps);
  });

  if (process.env.NODE_ENV !== 'production') {
    return setDisplayName(wrapDisplayName(BaseComponent, 'pure'))(hoc(BaseComponent));
  }

  return hoc(BaseComponent);
};

function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(undefined, arguments));
    };
  });
}

var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

























var taggedTemplateLiteral = function (strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
};

var _templateObject = taggedTemplateLiteral(['\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n'], ['\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n']);

var flexCenter = css(_templateObject);

var _templateObject$1 = taggedTemplateLiteral(['\n  0% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 1;\n  }\n  51% {\n    opacity: 0;\n  }\n'], ['\n  0% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 1;\n  }\n  51% {\n    opacity: 0;\n  }\n']);
var _templateObject2 = taggedTemplateLiteral(['\n    display: block;\n    font-size: 0;\n    color: ', ';\n    width: ', 'px;\n    height: ', 'px;\n    position: relative;\n    > div {\n      position: relative;\n      -webkit-box-sizing: border-box;\n        -moz-box-sizing: border-box;\n          box-sizing: border-box;\n    }\n    > div {\n      display: inline-block;\n      float: none;\n      background-color: currentColor;\n      border: 0 solid currentColor;\n    }\n    > div {\n      position: absolute;\n      top: 50%;\n      left: 50%;\n      width: ', 'px;\n      height: ', 'px;\n      border-radius: 0;\n      opacity: 0;\n      transform: translate(100%, 100%);\n      animation: ', ' 1s 0s ease infinite;\n    }\n    > div:nth-child(1) {\n      animation-delay: -.9375s;\n    }\n    > div:nth-child(2) {\n      animation-delay: -.875s;\n    }\n    > div:nth-child(3) {\n      animation-delay: -.8125s;\n    }\n    > div:nth-child(4) {\n      animation-delay: -.75s;\n    }\n    > div:nth-child(5) {\n      animation-delay: -.6875s;\n    }\n    > div:nth-child(6) {\n      animation-delay: -.625s;\n    }\n    > div:nth-child(7) {\n      animation-delay: -.5625s;\n    }\n    > div:nth-child(8) {\n      animation-delay: -.5s;\n    }\n    > div:nth-child(9) {\n      animation-delay: -.4375s;\n    }\n    > div:nth-child(10) {\n      animation-delay: -.375s;\n    }\n    > div:nth-child(11) {\n      animation-delay: -.3125s;\n    }\n    > div:nth-child(12) {\n      animation-delay: -.25s;\n    }\n    > div:nth-child(13) {\n      animation-delay: -.1875s;\n    }\n    > div:nth-child(14) {\n      animation-delay: -.125s;\n    }\n    > div:nth-child(15) {\n      animation-delay: -.0625s;\n    }\n    > div:nth-child(16) {\n      animation-delay: 0s;\n    }\n    > div:nth-child(1) {\n      top: -100%;\n      left: 0;\n    }\n    > div:nth-child(2) {\n      top: -100%;\n      left: 33.3333333333%;\n    }\n    > div:nth-child(3) {\n      top: -66.6666666667%;\n      left: 66.6666666667%;\n    }\n    > div:nth-child(4) {\n      top: -33.3333333333%;\n      left: 100%;\n    }\n    > div:nth-child(5) {\n      top: 0;\n      left: 100%;\n    }\n    > div:nth-child(6) {\n      top: 33.3333333333%;\n      left: 100%;\n    }\n    > div:nth-child(7) {\n      top: 66.6666666667%;\n      left: 66.6666666667%;\n    }\n    > div:nth-child(8) {\n      top: 100%;\n      left: 33.3333333333%;\n    }\n    > div:nth-child(9) {\n      top: 100%;\n      left: 0;\n    }\n    > div:nth-child(10) {\n      top: 100%;\n      left: -33.3333333333%;\n    }\n    > div:nth-child(11) {\n      top: 66.6666666667%;\n      left: -66.6666666667%;\n    }\n    > div:nth-child(12) {\n      top: 33.3333333333%;\n      left: -100%;\n    }\n    > div:nth-child(13) {\n      top: 0;\n      left: -100%;\n    }\n    > div:nth-child(14) {\n      top: -33.3333333333%;\n      left: -100%;\n    }\n    > div:nth-child(15) {\n      top: -66.6666666667%;\n      left: -66.6666666667%;\n    }\n    > div:nth-child(16) {\n      top: -100%;\n      left: -33.3333333333%;\n    }\n  '], ['\n    display: block;\n    font-size: 0;\n    color: ', ';\n    width: ', 'px;\n    height: ', 'px;\n    position: relative;\n    > div {\n      position: relative;\n      -webkit-box-sizing: border-box;\n        -moz-box-sizing: border-box;\n          box-sizing: border-box;\n    }\n    > div {\n      display: inline-block;\n      float: none;\n      background-color: currentColor;\n      border: 0 solid currentColor;\n    }\n    > div {\n      position: absolute;\n      top: 50%;\n      left: 50%;\n      width: ', 'px;\n      height: ', 'px;\n      border-radius: 0;\n      opacity: 0;\n      transform: translate(100%, 100%);\n      animation: ', ' 1s 0s ease infinite;\n    }\n    > div:nth-child(1) {\n      animation-delay: -.9375s;\n    }\n    > div:nth-child(2) {\n      animation-delay: -.875s;\n    }\n    > div:nth-child(3) {\n      animation-delay: -.8125s;\n    }\n    > div:nth-child(4) {\n      animation-delay: -.75s;\n    }\n    > div:nth-child(5) {\n      animation-delay: -.6875s;\n    }\n    > div:nth-child(6) {\n      animation-delay: -.625s;\n    }\n    > div:nth-child(7) {\n      animation-delay: -.5625s;\n    }\n    > div:nth-child(8) {\n      animation-delay: -.5s;\n    }\n    > div:nth-child(9) {\n      animation-delay: -.4375s;\n    }\n    > div:nth-child(10) {\n      animation-delay: -.375s;\n    }\n    > div:nth-child(11) {\n      animation-delay: -.3125s;\n    }\n    > div:nth-child(12) {\n      animation-delay: -.25s;\n    }\n    > div:nth-child(13) {\n      animation-delay: -.1875s;\n    }\n    > div:nth-child(14) {\n      animation-delay: -.125s;\n    }\n    > div:nth-child(15) {\n      animation-delay: -.0625s;\n    }\n    > div:nth-child(16) {\n      animation-delay: 0s;\n    }\n    > div:nth-child(1) {\n      top: -100%;\n      left: 0;\n    }\n    > div:nth-child(2) {\n      top: -100%;\n      left: 33.3333333333%;\n    }\n    > div:nth-child(3) {\n      top: -66.6666666667%;\n      left: 66.6666666667%;\n    }\n    > div:nth-child(4) {\n      top: -33.3333333333%;\n      left: 100%;\n    }\n    > div:nth-child(5) {\n      top: 0;\n      left: 100%;\n    }\n    > div:nth-child(6) {\n      top: 33.3333333333%;\n      left: 100%;\n    }\n    > div:nth-child(7) {\n      top: 66.6666666667%;\n      left: 66.6666666667%;\n    }\n    > div:nth-child(8) {\n      top: 100%;\n      left: 33.3333333333%;\n    }\n    > div:nth-child(9) {\n      top: 100%;\n      left: 0;\n    }\n    > div:nth-child(10) {\n      top: 100%;\n      left: -33.3333333333%;\n    }\n    > div:nth-child(11) {\n      top: 66.6666666667%;\n      left: -66.6666666667%;\n    }\n    > div:nth-child(12) {\n      top: 33.3333333333%;\n      left: -100%;\n    }\n    > div:nth-child(13) {\n      top: 0;\n      left: -100%;\n    }\n    > div:nth-child(14) {\n      top: -33.3333333333%;\n      left: -100%;\n    }\n    > div:nth-child(15) {\n      top: -66.6666666667%;\n      left: -66.6666666667%;\n    }\n    > div:nth-child(16) {\n      top: -100%;\n      left: -33.3333333333%;\n    }\n  ']);

var rotate = keyframes(_templateObject$1);

var props = function props(_ref) {
  var width = _ref.width,
      color = _ref.color;

  var BallBox = css(_templateObject2, color, width, width, width / 3, width / 3, rotate);
  return {
    BallBox: BallBox
  };
};

var Ball8bits = compose(pure, defaultProps({
  width: 12,
  color: '#fff',
  loading: false
}), withProps(props))(function (_ref2) {
  var loading = _ref2.loading,
      center = _ref2.center,
      BallBox = _ref2.BallBox;
  return React.createElement(
    'div',
    { className: cx('react-loading-wrap', defineProperty({}, flexCenter, center)) },
    loading ? React.createElement(
      'div',
      { className: BallBox },
      React.createElement('div', null),
      React.createElement('div', null),
      React.createElement('div', null),
      React.createElement('div', null),
      React.createElement('div', null),
      React.createElement('div', null),
      React.createElement('div', null),
      React.createElement('div', null),
      React.createElement('div', null),
      React.createElement('div', null),
      React.createElement('div', null),
      React.createElement('div', null),
      React.createElement('div', null),
      React.createElement('div', null),
      React.createElement('div', null),
      React.createElement('div', null)
    ) : null
  );
});

var _templateObject$2 = taggedTemplateLiteral(['\n  0% {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  50% {\n    -webkit-transform: rotate(180deg);\n    transform: rotate(180deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n'], ['\n  0% {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  50% {\n    -webkit-transform: rotate(180deg);\n    transform: rotate(180deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n']);
var _templateObject2$1 = taggedTemplateLiteral(['\n    position: relative;\n    box-sizing: border-box;\n    display: block;\n    font-size: 0;\n    color: ', ';\n    width: ', 'px;\n    height: ', 'px;\n\n    > div {\n      position: relative;\n      box-sizing: border-box;\n      display: inline-block;\n      float: none;\n      background-color: currentColor;\n      border: 0 solid currentColor;\n    }\n    > div {\n      width: ', 'px;\n      height: ', 'px;\n      background: transparent;\n      border-width: 2px;\n      border-bottom-color: transparent;\n      border-radius: 100%;\n      animation: ', ' .75s linear infinite;\n    }\n  '], ['\n    position: relative;\n    box-sizing: border-box;\n    display: block;\n    font-size: 0;\n    color: ', ';\n    width: ', 'px;\n    height: ', 'px;\n\n    > div {\n      position: relative;\n      box-sizing: border-box;\n      display: inline-block;\n      float: none;\n      background-color: currentColor;\n      border: 0 solid currentColor;\n    }\n    > div {\n      width: ', 'px;\n      height: ', 'px;\n      background: transparent;\n      border-width: 2px;\n      border-bottom-color: transparent;\n      border-radius: 100%;\n      animation: ', ' .75s linear infinite;\n    }\n  ']);

var rotate$1 = keyframes(_templateObject$2);
var props$1 = function props(_ref) {
  var color = _ref.color,
      width = _ref.width,
      height = _ref.height;

  var BallClipRotateBox = css(_templateObject2$1, color, width, height, width, height, rotate$1);
  return {
    BallClipRotateBox: BallClipRotateBox
  };
};
var BallClipRotate = compose(pure, defaultProps({
  width: 32,
  height: 32,
  loading: false,
  color: '#fff'
}), withProps(props$1))(function (_ref2) {
  var BallClipRotateBox = _ref2.BallClipRotateBox,
      center = _ref2.center,
      loading = _ref2.loading;
  return React.createElement(
    'div',
    { className: cx('react-loading-wrap', defineProperty({}, flexCenter, center)) },
    loading ? React.createElement(
      'div',
      { className: BallClipRotateBox },
      React.createElement('div', null)
    ) : null
  );
});

var _templateObject$3 = taggedTemplateLiteral(['\n  0% {\n    -webkit-transform: translate(-50%, -50%) rotate(0deg);\n    transform: translate(-50%, -50%) rotate(0deg);\n  }\n  50% {\n    -webkit-transform: translate(-50%, -50%) rotate(180deg);\n    transform: translate(-50%, -50%) rotate(180deg);\n  }\n  100% {\n    -webkit-transform: translate(-50%, -50%) rotate(360deg);\n    transform: translate(-50%, -50%) rotate(360deg);\n  }\n'], ['\n  0% {\n    -webkit-transform: translate(-50%, -50%) rotate(0deg);\n    transform: translate(-50%, -50%) rotate(0deg);\n  }\n  50% {\n    -webkit-transform: translate(-50%, -50%) rotate(180deg);\n    transform: translate(-50%, -50%) rotate(180deg);\n  }\n  100% {\n    -webkit-transform: translate(-50%, -50%) rotate(360deg);\n    transform: translate(-50%, -50%) rotate(360deg);\n  }\n']);
var _templateObject2$2 = taggedTemplateLiteral(['\n    position: relative;\n    box-sizing: border-box;\n    display: block;\n    font-size: 0;\n    color: ', ';\n    width: ', 'px;\n    height: ', 'px;\n\n    > div {\n      position: relative;\n      box-sizing: border-box;\n      display: inline-block;\n      float: none;\n      background-color: currentColor;\n      border: 0 solid currentColor;\n      position: absolute;\n      top: 50%;\n      left: 50%;\n      background: transparent;\n      border-style: solid;\n      border-width: 2px;\n      border-radius: 100%;\n      animation: ', ' 1s ease-in-out infinite;\n    }\n    > div:first-child {\n      position: absolute;\n      width: ', 'px;\n      height: ', 'px;\n      border-right-color: transparent;\n      border-left-color: transparent;\n    }\n    > div:last-child {\n      width: ', 'px;\n      height: ', 'px;\n      border-top-color: transparent;\n      border-bottom-color: transparent;\n      animation-duration: .5s;\n      animation-direction: reverse;\n    }\n  '], ['\n    position: relative;\n    box-sizing: border-box;\n    display: block;\n    font-size: 0;\n    color: ', ';\n    width: ', 'px;\n    height: ', 'px;\n\n    > div {\n      position: relative;\n      box-sizing: border-box;\n      display: inline-block;\n      float: none;\n      background-color: currentColor;\n      border: 0 solid currentColor;\n      position: absolute;\n      top: 50%;\n      left: 50%;\n      background: transparent;\n      border-style: solid;\n      border-width: 2px;\n      border-radius: 100%;\n      animation: ', ' 1s ease-in-out infinite;\n    }\n    > div:first-child {\n      position: absolute;\n      width: ', 'px;\n      height: ', 'px;\n      border-right-color: transparent;\n      border-left-color: transparent;\n    }\n    > div:last-child {\n      width: ', 'px;\n      height: ', 'px;\n      border-top-color: transparent;\n      border-bottom-color: transparent;\n      animation-duration: .5s;\n      animation-direction: reverse;\n    }\n  ']);

var rotate$2 = keyframes(_templateObject$3);
var props$2 = function props(_ref) {
  var width = _ref.width,
      height = _ref.height,
      color = _ref.color;

  var BallClipRotateMultiple = css(_templateObject2$2, color, width, height, rotate$2, width, width, width / 2, height / 2);
  return {
    BallClipRotateMultiple: BallClipRotateMultiple
  };
};
var BallClipRotateMultiple = compose(pure, defaultProps({
  width: 24,
  height: 24,
  color: '#fff',
  loading: false
}), withProps(props$2))(function (_ref2) {
  var center = _ref2.center,
      loading = _ref2.loading,
      BallClipRotateMultiple = _ref2.BallClipRotateMultiple;
  return React.createElement(
    'div',
    { className: cx('react-loading-wrap', defineProperty({}, flexCenter, center)) },
    loading ? React.createElement(
      'div',
      { className: BallClipRotateMultiple },
      React.createElement('div', null),
      React.createElement('div', null)
    ) : null
  );
});

var _templateObject$4 = taggedTemplateLiteral(['\n  0% {\n    -webkit-transform: translate(-50%, -50%) rotate(0deg);\n    transform: translate(-50%, -50%) rotate(0deg);\n  }\n  50% {\n    -webkit-transform: translate(-50%, -50%) rotate(180deg);\n    transform: translate(-50%, -50%) rotate(180deg);\n  }\n  100% {\n    -webkit-transform: translate(-50%, -50%) rotate(360deg);\n    transform: translate(-50%, -50%) rotate(360deg);\n  }\n'], ['\n  0% {\n    -webkit-transform: translate(-50%, -50%) rotate(0deg);\n    transform: translate(-50%, -50%) rotate(0deg);\n  }\n  50% {\n    -webkit-transform: translate(-50%, -50%) rotate(180deg);\n    transform: translate(-50%, -50%) rotate(180deg);\n  }\n  100% {\n    -webkit-transform: translate(-50%, -50%) rotate(360deg);\n    transform: translate(-50%, -50%) rotate(360deg);\n  }\n']);
var _templateObject2$3 = taggedTemplateLiteral(['\n  0%,\n  100% {\n    opacity: 1;\n    -webkit-transform: translate(-50%, -50%) scale(1);\n    transform: translate(-50%, -50%) scale(1);\n  }\n  30% {\n    opacity: .3;\n    -webkit-transform: translate(-50%, -50%) scale(.15);\n    transform: translate(-50%, -50%) scale(.15);\n  }\n'], ['\n  0%,\n  100% {\n    opacity: 1;\n    -webkit-transform: translate(-50%, -50%) scale(1);\n    transform: translate(-50%, -50%) scale(1);\n  }\n  30% {\n    opacity: .3;\n    -webkit-transform: translate(-50%, -50%) scale(.15);\n    transform: translate(-50%, -50%) scale(.15);\n  }\n']);
var _templateObject3 = taggedTemplateLiteral(['\n    position: relative;\n    box-sizing: border-box;\n    display: block;\n    font-size: 0;\n    color: ', ';\n    width: ', 'px;\n    height: ', 'px;\n    \n    > div {\n      position: relative;\n      box-sizing: border-box;\n      display: inline-block;\n      float: none;\n      background-color: currentColor;\n      border: 0 solid currentColor;\n      position: absolute;\n      top: 50%;\n      left: 50%;\n      border-radius: 100%;\n    }\n    > div:first-child {\n      position: absolute;\n      width: ', 'px;\n      height: ', 'px;\n      background: transparent;\n      border-style: solid;\n      border-width: 2px;\n      border-right-color: transparent;\n      border-left-color: transparent;\n      animation: ', ' 1s cubic-bezier(.09, .57, .49, .9) infinite;\n    }\n    > div:last-child {\n      width: ', 'px;\n      height: ', 'px;\n      animation: ', ' 1s cubic-bezier(.09, .57, .49, .9) infinite;\n    }\n  '], ['\n    position: relative;\n    box-sizing: border-box;\n    display: block;\n    font-size: 0;\n    color: ', ';\n    width: ', 'px;\n    height: ', 'px;\n    \n    > div {\n      position: relative;\n      box-sizing: border-box;\n      display: inline-block;\n      float: none;\n      background-color: currentColor;\n      border: 0 solid currentColor;\n      position: absolute;\n      top: 50%;\n      left: 50%;\n      border-radius: 100%;\n    }\n    > div:first-child {\n      position: absolute;\n      width: ', 'px;\n      height: ', 'px;\n      background: transparent;\n      border-style: solid;\n      border-width: 2px;\n      border-right-color: transparent;\n      border-left-color: transparent;\n      animation: ', ' 1s cubic-bezier(.09, .57, .49, .9) infinite;\n    }\n    > div:last-child {\n      width: ', 'px;\n      height: ', 'px;\n      animation: ', ' 1s cubic-bezier(.09, .57, .49, .9) infinite;\n    }\n  ']);

var rotate$3 = keyframes(_templateObject$4);
var scale = keyframes(_templateObject2$3);
var props$3 = function props(_ref) {
  var width = _ref.width,
      height = _ref.height,
      color = _ref.color;

  var BallClipRotatePulse = css(_templateObject3, color, width, height, width, height, rotate$3, width / 2, height / 2, scale);
  return {
    BallClipRotatePulse: BallClipRotatePulse
  };
};
var BallClipRotatePulse = compose(pure, defaultProps({
  width: 24,
  height: 24,
  color: '#fff',
  loading: false
}), withProps(props$3))(function (_ref2) {
  var center = _ref2.center,
      loading = _ref2.loading,
      BallClipRotatePulse = _ref2.BallClipRotatePulse;
  return React.createElement(
    'div',
    { className: cx('react-loading-wrap', defineProperty({}, flexCenter, center)) },
    loading ? React.createElement(
      'div',
      { className: BallClipRotatePulse },
      React.createElement('div', null),
      React.createElement('div', null)
    ) : null
  );
});

var _templateObject$5 = taggedTemplateLiteral(['\n  50% {\n    top: 100%;\n    left: 100%;\n  }\n'], ['\n  50% {\n    top: 100%;\n    left: 100%;\n  }\n']);
var _templateObject2$4 = taggedTemplateLiteral(['\n  50% {\n    transform: scale(.5, .5);\n  }\n'], ['\n  50% {\n    transform: scale(.5, .5);\n  }\n']);
var _templateObject3$1 = taggedTemplateLiteral(['\n  50% {\n    z-index: 10;\n  }\n'], ['\n  50% {\n    z-index: 10;\n  }\n']);
var _templateObject4 = taggedTemplateLiteral(['\n  50% {\n    transform: translate(-50%, -50%) scale(.8, .8);\n  }\n'], ['\n  50% {\n    transform: translate(-50%, -50%) scale(.8, .8);\n  }\n']);
var _templateObject5 = taggedTemplateLiteral(['\n    position: relative;\n    -webkit-box-sizing: border-box;\n    -moz-box-sizing: border-box;\n    box-sizing: border-box;\n    display: block;\n    font-size: 0;\n    color: ', ';\n    width: ', 'px;\n    height: ', 'px;\n\n    > div {\n      position: relative;\n      -webkit-box-sizing: border-box;\n      -moz-box-sizing: border-box;\n      box-sizing: border-box;\n      display: inline-block;\n      float: none;\n      background-color: currentColor;\n      border: 0 solid currentColor;\n    }\n    > div:nth-child(1) {\n      position: absolute;\n      top: 50%;\n      left: 50%;\n      z-index: 1;\n      width: 60%;\n      height: 60%;\n      background: #aaa;\n      border-radius: 100%;\n      transform: translate(-50%, -50%);\n      animation: ', ' 4.5s infinite linear;\n    }\n    > div:not(:nth-child(1)) {\n      position: absolute;\n      left: 0;\n      z-index: 0;\n      width: 100%;\n      height: 100%;\n      background: none;\n      animation: ', ' 1.5s 0s infinite steps(2, end);\n    }\n    > div:not(:nth-child(1)):before {\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: ', 'px;\n      height: ', 'px;\n      margin-top: ', 'px;\n      margin-left: ', 'px;\n      content: "";\n      background: currentColor;\n      border-radius: 50%;\n      opacity: .75;\n      animation: ', ' 1.5s 0s infinite ease, ', ' 1.5s 0s infinite ease;\n    }\n    > div:nth-child(2) {\n      animation-delay: .75s;\n    }\n    > div:nth-child(2):before {\n      animation-delay: 0s, -1.125s;\n    }\n    > div:nth-child(3) {\n      transform: rotate(120deg);\n      animation-delay: -.25s;\n    }\n    > div:nth-child(3):before {\n        animation-delay: -1s, -.75s;\n    }\n    > div:nth-child(4) {\n      transform: rotate(240deg);\n      animation-delay: .25s;\n    }\n    > div:nth-child(4):before {\n      animation-delay: -.5s, -.125s;\n    }\n  '], ['\n    position: relative;\n    -webkit-box-sizing: border-box;\n    -moz-box-sizing: border-box;\n    box-sizing: border-box;\n    display: block;\n    font-size: 0;\n    color: ', ';\n    width: ', 'px;\n    height: ', 'px;\n\n    > div {\n      position: relative;\n      -webkit-box-sizing: border-box;\n      -moz-box-sizing: border-box;\n      box-sizing: border-box;\n      display: inline-block;\n      float: none;\n      background-color: currentColor;\n      border: 0 solid currentColor;\n    }\n    > div:nth-child(1) {\n      position: absolute;\n      top: 50%;\n      left: 50%;\n      z-index: 1;\n      width: 60%;\n      height: 60%;\n      background: #aaa;\n      border-radius: 100%;\n      transform: translate(-50%, -50%);\n      animation: ', ' 4.5s infinite linear;\n    }\n    > div:not(:nth-child(1)) {\n      position: absolute;\n      left: 0;\n      z-index: 0;\n      width: 100%;\n      height: 100%;\n      background: none;\n      animation: ', ' 1.5s 0s infinite steps(2, end);\n    }\n    > div:not(:nth-child(1)):before {\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: ', 'px;\n      height: ', 'px;\n      margin-top: ', 'px;\n      margin-left: ', 'px;\n      content: "";\n      background: currentColor;\n      border-radius: 50%;\n      opacity: .75;\n      animation: ', ' 1.5s 0s infinite ease, ', ' 1.5s 0s infinite ease;\n    }\n    > div:nth-child(2) {\n      animation-delay: .75s;\n    }\n    > div:nth-child(2):before {\n      animation-delay: 0s, -1.125s;\n    }\n    > div:nth-child(3) {\n      transform: rotate(120deg);\n      animation-delay: -.25s;\n    }\n    > div:nth-child(3):before {\n        animation-delay: -1s, -.75s;\n    }\n    > div:nth-child(4) {\n      transform: rotate(240deg);\n      animation-delay: .25s;\n    }\n    > div:nth-child(4):before {\n      animation-delay: -.5s, -.125s;\n    }\n  ']);

var BallAtomPosition = keyframes(_templateObject$5);
var BallAtomSize = keyframes(_templateObject2$4);
var BallAtomZindex = keyframes(_templateObject3$1);
var BallAtomShrink = keyframes(_templateObject4);
var props$4 = function props(_ref) {
  var width = _ref.width,
      height = _ref.height,
      color = _ref.color;

  var BallAtom = css(_templateObject5, color, width, width, BallAtomShrink, BallAtomZindex, width / 3.2, width / 3.2, width / 3.2 / 2, width / 3.2 / 2, BallAtomPosition, BallAtomSize);
  return {
    BallAtom: BallAtom
  };
};
var BallAtom = compose(pure, defaultProps({
  width: 24,
  color: '#fff',
  loading: false
}), withProps(props$4))(function (_ref2) {
  var center = _ref2.center,
      loading = _ref2.loading,
      BallAtom = _ref2.BallAtom;
  return React.createElement(
    'div',
    { className: cx('react-loading-wrap', defineProperty({}, flexCenter, center)) },
    loading ? React.createElement(
      'div',
      { className: BallAtom },
      React.createElement('div', null),
      React.createElement('div', null),
      React.createElement('div', null),
      React.createElement('div', null)
    ) : null
  );
});

var _templateObject$6 = taggedTemplateLiteral(['\n  50% {\n    opacity: .2;\n    transform: scale(.75);\n  }\n  100% {\n    opacity: 1;\n    transform: scale(1);\n  }\n'], ['\n  50% {\n    opacity: .2;\n    transform: scale(.75);\n  }\n  100% {\n    opacity: 1;\n    transform: scale(1);\n  }\n']);
var _templateObject2$5 = taggedTemplateLiteral(['\n    position: relative;\n    box-sizing: border-box;\n    display: block;\n    font-size: 0;\n    color: ', ';\n    width: ', 'px;\n    height: ', 'px;\n\n    > div {\n      position: relative;\n      box-sizing: border-box;\n      display: inline-block;\n      float: none;\n      background-color: currentColor;\n      border: 0 solid currentColor;\n      width: ', 'px;\n      height: ', 'px;\n      margin: ', 'px;\n      border-radius: 100%;\n      animation: ', ' .7s -.15s infinite linear;\n    }\n    > div:nth-child(2n-1) {\n      animation-delay: -.5s;\n    }\n  '], ['\n    position: relative;\n    box-sizing: border-box;\n    display: block;\n    font-size: 0;\n    color: ', ';\n    width: ', 'px;\n    height: ', 'px;\n\n    > div {\n      position: relative;\n      box-sizing: border-box;\n      display: inline-block;\n      float: none;\n      background-color: currentColor;\n      border: 0 solid currentColor;\n      width: ', 'px;\n      height: ', 'px;\n      margin: ', 'px;\n      border-radius: 100%;\n      animation: ', ' .7s -.15s infinite linear;\n    }\n    > div:nth-child(2n-1) {\n      animation-delay: -.5s;\n    }\n  ']);

var BallBeatOpacity = keyframes(_templateObject$6);
var props$5 = function props(_ref) {
  var width = _ref.width,
      color = _ref.color;

  var bWidth = width;
  var bHeight = width / 3;

  var sMargin = bHeight / 2.25 / 2;
  var sWidth = bHeight - sMargin * 2;
  var sHeight = bHeight - sMargin * 2;

  var BallBeat = css(_templateObject2$5, color, bWidth, bHeight, sWidth, sHeight, sMargin, BallBeatOpacity);
  return {
    BallBeat: BallBeat
  };
};
var BallBeat = compose(pure, defaultProps({
  width: 54,
  color: '#fff',
  loading: false
}), withProps(props$5))(function (_ref2) {
  var center = _ref2.center,
      loading = _ref2.loading,
      BallBeat = _ref2.BallBeat;
  return React.createElement(
    'div',
    { className: cx('react-loading-wrap', defineProperty({}, flexCenter, center)) },
    loading ? React.createElement(
      'div',
      { className: BallBeat },
      React.createElement('div', null),
      React.createElement('div', null),
      React.createElement('div', null)
    ) : null
  );
});

var _templateObject$7 = taggedTemplateLiteral(['\n  50% {\n    left: 100%;\n  }\n'], ['\n  50% {\n    left: 100%;\n  }\n']);
var _templateObject2$6 = taggedTemplateLiteral(['\n  50% {\n    transform: scale(.3, .3);\n  }\n'], ['\n  50% {\n    transform: scale(.3, .3);\n  }\n']);
var _templateObject3$2 = taggedTemplateLiteral(['\n    position: relative;\n    box-sizing: border-box;\n    display: block;\n    font-size: 0;\n    color: ', ';\n    width: ', 'px;\n    height: ', 'px;\n\n    > div {\n      position: relative;\n      box-sizing: border-box;\n      display: inline-block;\n      float: none;\n      background-color: currentColor;\n      border: 0 solid currentColor;\n      position: absolute;\n      top: 0;\n      left: -100%;\n      display: block;\n      width: ', 'px;\n      width: 100%;\n      height: ', 'px;\n      height: 100%;\n      border-radius: 100%;\n      opacity: .5;\n      animation: ', ' 2.5s infinite cubic-bezier(.25, 0, .75, 1), ', ' 2.5s infinite cubic-bezier(.25, 0, .75, 1);\n    }\n    > div:nth-child(1) {\n      animation-delay: 0s, -.5s;\n    }\n    > div:nth-child(2) {\n      animation-delay: -.5s, -1s;\n    }\n    > div:nth-child(3) {\n      animation-delay: -1s, -1.5s;\n    }\n    > div:nth-child(4) {\n      animation-delay: -1.5s, -2s;\n    }\n    > div:nth-child(5) {\n      animation-delay: -2s, -2.5s;\n    }\n  '], ['\n    position: relative;\n    box-sizing: border-box;\n    display: block;\n    font-size: 0;\n    color: ', ';\n    width: ', 'px;\n    height: ', 'px;\n\n    > div {\n      position: relative;\n      box-sizing: border-box;\n      display: inline-block;\n      float: none;\n      background-color: currentColor;\n      border: 0 solid currentColor;\n      position: absolute;\n      top: 0;\n      left: -100%;\n      display: block;\n      width: ', 'px;\n      width: 100%;\n      height: ', 'px;\n      height: 100%;\n      border-radius: 100%;\n      opacity: .5;\n      animation: ', ' 2.5s infinite cubic-bezier(.25, 0, .75, 1), ', ' 2.5s infinite cubic-bezier(.25, 0, .75, 1);\n    }\n    > div:nth-child(1) {\n      animation-delay: 0s, -.5s;\n    }\n    > div:nth-child(2) {\n      animation-delay: -.5s, -1s;\n    }\n    > div:nth-child(3) {\n      animation-delay: -1s, -1.5s;\n    }\n    > div:nth-child(4) {\n      animation-delay: -1.5s, -2s;\n    }\n    > div:nth-child(5) {\n      animation-delay: -2s, -2.5s;\n    }\n  ']);

var position = keyframes(_templateObject$7);
var size = keyframes(_templateObject2$6);
var props$6 = function props(_ref) {
  var color = _ref.color,
      width = _ref.width,
      height = _ref.height;

  var BallCircus = css(_templateObject3$2, color, width, width, width, height, position, size);
  return {
    BallCircus: BallCircus
  };
};
var BallCircus = compose(pure, defaultProps({
  width: 24,
  height: 24,
  color: '#fff',
  loading: false
}), withProps(props$6))(function (_ref2) {
  var center = _ref2.center,
      loading = _ref2.loading,
      BallCircus = _ref2.BallCircus;
  return React.createElement(
    'div',
    { className: cx('react-loading-wrap', defineProperty({}, flexCenter, center)) },
    loading ? React.createElement(
      'div',
      { className: BallCircus },
      React.createElement('div', null),
      React.createElement('div', null),
      React.createElement('div', null),
      React.createElement('div', null),
      React.createElement('div', null)
    ) : null
  );
});

var _templateObject$8 = taggedTemplateLiteral(['\n  0% {\n    transform: scale(1, .7);\n  }\n  20% {\n    transform: scale(.7, 1.2);\n  }\n  40% {\n    transform: scale(1, 1);\n  }\n  50% {\n    bottom: 125%;\n  }\n  46% {\n    transform: scale(1, 1);\n  }\n  80% {\n    transform: scale(.7, 1.2);\n  }\n  90% {\n    transform: scale(.7, 1.2);\n  }\n  100% {\n    transform: scale(1, .7);\n  }\n'], ['\n  0% {\n    transform: scale(1, .7);\n  }\n  20% {\n    transform: scale(.7, 1.2);\n  }\n  40% {\n    transform: scale(1, 1);\n  }\n  50% {\n    bottom: 125%;\n  }\n  46% {\n    transform: scale(1, 1);\n  }\n  80% {\n    transform: scale(.7, 1.2);\n  }\n  90% {\n    transform: scale(.7, 1.2);\n  }\n  100% {\n    transform: scale(1, .7);\n  }\n']);
var _templateObject2$7 = taggedTemplateLiteral(['\n  0% {\n    top: 0;\n    right: 0;\n    opacity: 0;\n  }\n  50% {\n    opacity: 1;\n  }\n  100% {\n    top: 100%;\n    right: 100%;\n    opacity: 0;\n  }\n'], ['\n  0% {\n    top: 0;\n    right: 0;\n    opacity: 0;\n  }\n  50% {\n    opacity: 1;\n  }\n  100% {\n    top: 100%;\n    right: 100%;\n    opacity: 0;\n  }\n']);
var _templateObject3$3 = taggedTemplateLiteral(['\n    position: relative;\n    box-sizing: border-box;\n    display: block;\n    font-size: 0;\n    color: ', ';\n    width: ', 'px;\n    height: ', 'px;\n\n    > div {\n      display: inline-block;\n      float: none;\n      background-color: currentColor;\n      border: 0 solid currentColor;\n    }\n    > div:nth-child(1) {\n      position: absolute;\n      bottom: 32%;\n      left: 18%;\n      width: ', 'px;\n      height: ', 'px;\n      border-radius: 100%;\n      transform-origin: center bottom;\n      animation: ', ' .6s ease-in-out infinite;\n    }\n    > div:not(:nth-child(1)) {\n      position: absolute;\n      top: 0;\n      right: 0;\n      width: ', 'px;\n      height: ', 'px;\n      border-radius: 0;\n      transform: translate(60%, 0);\n      animation: ', ' 1.8s linear infinite;\n    }\n    > div:not(:nth-child(1)):nth-child(2) {\n        animation-delay: 0ms;\n    }\n    > div:not(:nth-child(1)):nth-child(3) {\n      animation-delay: -600ms;\n    }\n    > div:not(:nth-child(1)):nth-child(4) {\n      animation-delay: -1200ms;\n    }\n  '], ['\n    position: relative;\n    box-sizing: border-box;\n    display: block;\n    font-size: 0;\n    color: ', ';\n    width: ', 'px;\n    height: ', 'px;\n\n    > div {\n      display: inline-block;\n      float: none;\n      background-color: currentColor;\n      border: 0 solid currentColor;\n    }\n    > div:nth-child(1) {\n      position: absolute;\n      bottom: 32%;\n      left: 18%;\n      width: ', 'px;\n      height: ', 'px;\n      border-radius: 100%;\n      transform-origin: center bottom;\n      animation: ', ' .6s ease-in-out infinite;\n    }\n    > div:not(:nth-child(1)) {\n      position: absolute;\n      top: 0;\n      right: 0;\n      width: ', 'px;\n      height: ', 'px;\n      border-radius: 0;\n      transform: translate(60%, 0);\n      animation: ', ' 1.8s linear infinite;\n    }\n    > div:not(:nth-child(1)):nth-child(2) {\n        animation-delay: 0ms;\n    }\n    > div:not(:nth-child(1)):nth-child(3) {\n      animation-delay: -600ms;\n    }\n    > div:not(:nth-child(1)):nth-child(4) {\n      animation-delay: -1200ms;\n    }\n  ']);

var dotJump = keyframes(_templateObject$8);
var dotStep = keyframes(_templateObject2$7);
var props$7 = function props(_ref) {
  var color = _ref.color,
      width = _ref.width;

  var ratio = 1.3125;
  var boxWidth = width;
  var boxHeight = width / ratio;
  var smallMeasure = width / 3;

  var BallClimbingDot = css(_templateObject3$3, color, boxWidth, boxHeight, smallMeasure, smallMeasure, dotJump, smallMeasure, smallMeasure / 7, dotStep);
  return {
    BallClimbingDot: BallClimbingDot
  };
};
var BallClimbingDot = compose(pure, defaultProps({
  width: 42,
  color: '#fff',
  loading: false
}), withProps(props$7))(function (_ref2) {
  var center = _ref2.center,
      loading = _ref2.loading,
      BallClimbingDot = _ref2.BallClimbingDot;
  return React.createElement(
    'div',
    { className: cx('react-loading-wrap', defineProperty({}, flexCenter, center)) },
    loading ? React.createElement(
      'div',
      { className: BallClimbingDot },
      React.createElement('div', null),
      React.createElement('div', null),
      React.createElement('div', null),
      React.createElement('div', null)
    ) : null
  );
});

var _templateObject$9 = taggedTemplateLiteral(['\n  0%,\n  100% {\n    margin: 0;\n    transform: scale(1);\n  }\n  50% {\n    margin: 0 5%;\n    transform: scale(.65);\n  }\n'], ['\n  0%,\n  100% {\n    margin: 0;\n    transform: scale(1);\n  }\n  50% {\n    margin: 0 5%;\n    transform: scale(.65);\n  }\n']);
var _templateObject2$8 = taggedTemplateLiteral(['\n    position: relative;\n    box-sizing: border-box;\n    display: block;\n    font-size: 0;\n    color: ', ';\n    width: ', 'px;\n    height: ', 'px;\n    font-size: 0;\n    text-align: center;\n\n    > div {\n      position: relative;\n      box-sizing: border-box;\n      display: inline-block;\n      float: none;\n      background-color: currentColor;\n      border: 0 solid currentColor;\n      display: inline-block;\n      width: ', 'px;\n      height: ', 'px;\n      white-space: nowrap;\n      border-radius: 100%;\n      animation: ', ' 1s infinite;\n    }\n  '], ['\n    position: relative;\n    box-sizing: border-box;\n    display: block;\n    font-size: 0;\n    color: ', ';\n    width: ', 'px;\n    height: ', 'px;\n    font-size: 0;\n    text-align: center;\n\n    > div {\n      position: relative;\n      box-sizing: border-box;\n      display: inline-block;\n      float: none;\n      background-color: currentColor;\n      border: 0 solid currentColor;\n      display: inline-block;\n      width: ', 'px;\n      height: ', 'px;\n      white-space: nowrap;\n      border-radius: 100%;\n      animation: ', ' 1s infinite;\n    }\n  ']);

var dotsAnim = keyframes(_templateObject$9);
var props$8 = function props(_ref) {
  var color = _ref.color,
      width = _ref.width;

  var BallElasticDots = css(_templateObject2$8, color, width, width / 12, width / 12, width / 12, dotsAnim);
  return {
    BallElasticDots: BallElasticDots
  };
};
var BallElasticDots = compose(pure, defaultProps({
  width: 240,
  color: '#fff',
  loading: false
}), withProps(props$8))(function (_ref2) {
  var center = _ref2.center,
      loading = _ref2.loading,
      BallElasticDots = _ref2.BallElasticDots;
  return React.createElement(
    'div',
    { className: cx('react-loading-wrap', defineProperty({}, flexCenter, center)) },
    loading ? React.createElement(
      'div',
      { className: BallElasticDots },
      React.createElement('div', null),
      React.createElement('div', null),
      React.createElement('div', null),
      React.createElement('div', null),
      React.createElement('div', null)
    ) : null
  );
});

var _templateObject$10 = taggedTemplateLiteral(['\n  0% {\n    opacity: 0;\n    transform: translateY(-145%);\n  }\n  10% {\n    opacity: .5;\n  }\n  20% {\n    opacity: 1;\n    transform: translateY(0);\n  }\n  80% {\n    opacity: 1;\n    transform: translateY(0);\n  }\n  90% {\n    opacity: .5;\n  }\n  100% {\n    opacity: 0;\n    transform: translateY(145%);\n  }\n'], ['\n  0% {\n    opacity: 0;\n    transform: translateY(-145%);\n  }\n  10% {\n    opacity: .5;\n  }\n  20% {\n    opacity: 1;\n    transform: translateY(0);\n  }\n  80% {\n    opacity: 1;\n    transform: translateY(0);\n  }\n  90% {\n    opacity: .5;\n  }\n  100% {\n    opacity: 0;\n    transform: translateY(145%);\n  }\n']);
var _templateObject2$9 = taggedTemplateLiteral(['\n    position: relative;\n    box-sizing: border-box;\n    display: block;\n    font-size: 0;\n    color: ', ';\n    width: ', 'px;\n    height: ', 'px;\n\n    > div {\n      position: relative;\n      box-sizing: border-box;\n      display: inline-block;\n      float: none;\n      background-color: currentColor;\n      border: 0 solid currentColor;\n    }\n    > div {\n      width: ', 'px;\n      height: ', 'px;\n      margin: ', 'px;\n      border-radius: 100%;\n      opacity: 0;\n      animation: ', ' 1s ease-in-out infinite;\n    }\n    > div:nth-child(1) {\n      animation-delay: -200ms;\n    }\n    > div:nth-child(2) {\n      animation-delay: -100ms;\n    }\n    > div:nth-child(3) {\n      animation-delay: 0ms;\n    }\n  '], ['\n    position: relative;\n    box-sizing: border-box;\n    display: block;\n    font-size: 0;\n    color: ', ';\n    width: ', 'px;\n    height: ', 'px;\n\n    > div {\n      position: relative;\n      box-sizing: border-box;\n      display: inline-block;\n      float: none;\n      background-color: currentColor;\n      border: 0 solid currentColor;\n    }\n    > div {\n      width: ', 'px;\n      height: ', 'px;\n      margin: ', 'px;\n      border-radius: 100%;\n      opacity: 0;\n      animation: ', ' 1s ease-in-out infinite;\n    }\n    > div:nth-child(1) {\n      animation-delay: -200ms;\n    }\n    > div:nth-child(2) {\n      animation-delay: -100ms;\n    }\n    > div:nth-child(3) {\n      animation-delay: 0ms;\n    }\n  ']);

var rotate$4 = keyframes(_templateObject$10);
var props$9 = function props(_ref) {
  var width = _ref.width,
      color = _ref.color;

  var smallBall = width / 3 / 1.8;

  var BallFall = css(_templateObject2$9, color, width, width / 3, smallBall, smallBall, smallBall / 2.5, rotate$4);
  return {
    BallFall: BallFall
  };
};
var BallFall = compose(pure, defaultProps({
  width: 54,
  color: '#fff',
  loading: false
}), withProps(props$9))(function (_ref2) {
  var center = _ref2.center,
      loading = _ref2.loading,
      BallFall = _ref2.BallFall;
  return React.createElement(
    'div',
    { className: cx('react-loading-wrap', defineProperty({}, flexCenter, center)) },
    loading ? React.createElement(
      'div',
      { className: BallFall },
      React.createElement('div', null),
      React.createElement('div', null),
      React.createElement('div', null)
    ) : null
  );
});

var _templateObject$11 = taggedTemplateLiteral(['\n  0% {\n    opacity: .35;\n  }\n  50% {\n    top: -100%;\n    left: 200%;\n    opacity: 1;\n  }\n  100% {\n    top: 50%;\n    left: 100%;\n    z-index: 2;\n    opacity: .35;\n  }\n'], ['\n  0% {\n    opacity: .35;\n  }\n  50% {\n    top: -100%;\n    left: 200%;\n    opacity: 1;\n  }\n  100% {\n    top: 50%;\n    left: 100%;\n    z-index: 2;\n    opacity: .35;\n  }\n']);
var _templateObject2$10 = taggedTemplateLiteral(['\n  0% {\n    opacity: .35;\n  }\n  50% {\n    top: 200%;\n    left: 200%;\n    opacity: 1;\n  }\n  100% {\n    top: 100%;\n    left: 50%;\n    z-index: 1;\n    opacity: .35;\n  }\n'], ['\n  0% {\n    opacity: .35;\n  }\n  50% {\n    top: 200%;\n    left: 200%;\n    opacity: 1;\n  }\n  100% {\n    top: 100%;\n    left: 50%;\n    z-index: 1;\n    opacity: .35;\n  }\n']);
var _templateObject3$4 = taggedTemplateLiteral(['\n  0% {\n    opacity: .35;\n  }\n  50% {\n    top: 200%;\n    left: -100%;\n    opacity: 1;\n  }\n  100% {\n    top: 50%;\n    left: 0;\n    z-index: 2;\n    opacity: .35;\n  }\n'], ['\n  0% {\n    opacity: .35;\n  }\n  50% {\n    top: 200%;\n    left: -100%;\n    opacity: 1;\n  }\n  100% {\n    top: 50%;\n    left: 0;\n    z-index: 2;\n    opacity: .35;\n  }\n']);
var _templateObject4$1 = taggedTemplateLiteral(['\n  0% {\n    opacity: .35;\n  }\n  50% {\n    top: -100%;\n    left: -100%;\n    opacity: 1;\n  }\n  100% {\n    top: 0;\n    left: 50%;\n    z-index: 1;\n    opacity: .35;\n  }\n'], ['\n  0% {\n    opacity: .35;\n  }\n  50% {\n    top: -100%;\n    left: -100%;\n    opacity: 1;\n  }\n  100% {\n    top: 0;\n    left: 50%;\n    z-index: 1;\n    opacity: .35;\n  }\n']);
var _templateObject5$1 = taggedTemplateLiteral(['\n    position: relative;\n    box-sizing: border-box;\n    display: block;\n    font-size: 0;\n    color: ', ';\n    width: ', 'px;\n    height: ', 'px;\n\n    > div {\n      display: inline-block;\n      float: none;\n      background-color: currentColor;\n      border: 0 solid currentColor;\n      position: absolute;\n      width: ', 'px;\n      height: ', 'px;\n      border-radius: 100%;\n      transform: translate(-50%, -50%);\n      animation: ', ' 1s 0s ease infinite;\n    }\n    > div:nth-child(1) {\n      top: 0;\n      left: 50%;\n      z-index: 1;\n    }\n    > div:nth-child(2) {\n      top: 50%;\n      left: 100%;\n      z-index: 2;\n      animation-name: ', ';\n    }\n    > div:nth-child(3) {\n        top: 100%;\n        left: 50%;\n        z-index: 1;\n        animation-name: ', ';\n    }\n    > div:nth-child(4) {\n        top: 50%;\n        left: 0;\n        z-index: 2;\n        animation-name: ', ';\n    }\n  '], ['\n    position: relative;\n    box-sizing: border-box;\n    display: block;\n    font-size: 0;\n    color: ', ';\n    width: ', 'px;\n    height: ', 'px;\n\n    > div {\n      display: inline-block;\n      float: none;\n      background-color: currentColor;\n      border: 0 solid currentColor;\n      position: absolute;\n      width: ', 'px;\n      height: ', 'px;\n      border-radius: 100%;\n      transform: translate(-50%, -50%);\n      animation: ', ' 1s 0s ease infinite;\n    }\n    > div:nth-child(1) {\n      top: 0;\n      left: 50%;\n      z-index: 1;\n    }\n    > div:nth-child(2) {\n      top: 50%;\n      left: 100%;\n      z-index: 2;\n      animation-name: ', ';\n    }\n    > div:nth-child(3) {\n        top: 100%;\n        left: 50%;\n        z-index: 1;\n        animation-name: ', ';\n    }\n    > div:nth-child(4) {\n        top: 50%;\n        left: 0;\n        z-index: 2;\n        animation-name: ', ';\n    }\n  ']);

var Ball1 = keyframes(_templateObject$11);
var Ball2 = keyframes(_templateObject2$10);
var Ball3 = keyframes(_templateObject3$4);
var Ball4 = keyframes(_templateObject4$1);
var props$10 = function props(_ref) {
  var color = _ref.color,
      width = _ref.width;

  var BallFussion = css(_templateObject5$1, color, width, width, width * 1.5, width * 1.5, Ball1, Ball2, Ball3, Ball4);
  return {
    BallFussion: BallFussion
  };
};
var BallFussion = compose(pure, defaultProps({
  width: 12,
  color: '#fff',
  loading: false
}), withProps(props$10))(function (_ref2) {
  var center = _ref2.center,
      loading = _ref2.loading,
      BallFussion = _ref2.BallFussion;
  return React.createElement(
    'div',
    { className: cx('react-loading-wrap', defineProperty({}, flexCenter, center)) },
    loading ? React.createElement(
      'div',
      { className: BallFussion },
      React.createElement('div', null),
      React.createElement('div', null),
      React.createElement('div', null),
      React.createElement('div', null)
    ) : null
  );
});

var _templateObject$12 = taggedTemplateLiteral(['\n  0% {\n    opacity: 1;\n  }\n  50% {\n    opacity: .35;\n  }\n  100% {\n    opacity: 1;\n  }\n'], ['\n  0% {\n    opacity: 1;\n  }\n  50% {\n    opacity: .35;\n  }\n  100% {\n    opacity: 1;\n  }\n']);
var _templateObject2$11 = taggedTemplateLiteral(['\n    position: relative;\n    box-sizing: border-box;\n    display: block;\n    font-size: 0;\n    color: ', ';\n    width: ', 'px;\n    height: ', 'px;\n\n    > div {\n      display: inline-block;\n      float: none;\n      background-color: currentColor;\n      border: 0 solid currentColor;\n      width: ', 'px;\n      height: ', 'px;\n      margin: ', 'px;\n      border-radius: 100%;\n      animation-name: ', ';\n      animation-iteration-count: infinite;\n    }\n    > div:nth-child(1) {\n      animation-duration: .65s;\n      animation-delay: .03s;\n    }\n    > div:nth-child(2) {\n      animation-duration: 1.02s;\n      animation-delay: .09s;\n    }\n    > div:nth-child(3) {\n      animation-duration: 1.06s;\n      animation-delay: -.69s;\n    }\n    > div:nth-child(4) {\n      animation-duration: 1.5s;\n      animation-delay: -.41s;\n    }\n    > div:nth-child(5) {\n      animation-duration: 1.6s;\n      animation-delay: .04s;\n    }\n    > div:nth-child(6) {\n      animation-duration: .84s;\n      animation-delay: .07s;\n    }\n    > div:nth-child(7) {\n      animation-duration: .68s;\n      animation-delay: -.66s;\n    }\n    > div:nth-child(8) {\n      animation-duration: .93s;\n      animation-delay: -.76s;\n    }\n    > div:nth-child(9) {\n      animation-duration: 1.24s;\n      animation-delay: -.76s;\n    }\n  '], ['\n    position: relative;\n    box-sizing: border-box;\n    display: block;\n    font-size: 0;\n    color: ', ';\n    width: ', 'px;\n    height: ', 'px;\n\n    > div {\n      display: inline-block;\n      float: none;\n      background-color: currentColor;\n      border: 0 solid currentColor;\n      width: ', 'px;\n      height: ', 'px;\n      margin: ', 'px;\n      border-radius: 100%;\n      animation-name: ', ';\n      animation-iteration-count: infinite;\n    }\n    > div:nth-child(1) {\n      animation-duration: .65s;\n      animation-delay: .03s;\n    }\n    > div:nth-child(2) {\n      animation-duration: 1.02s;\n      animation-delay: .09s;\n    }\n    > div:nth-child(3) {\n      animation-duration: 1.06s;\n      animation-delay: -.69s;\n    }\n    > div:nth-child(4) {\n      animation-duration: 1.5s;\n      animation-delay: -.41s;\n    }\n    > div:nth-child(5) {\n      animation-duration: 1.6s;\n      animation-delay: .04s;\n    }\n    > div:nth-child(6) {\n      animation-duration: .84s;\n      animation-delay: .07s;\n    }\n    > div:nth-child(7) {\n      animation-duration: .68s;\n      animation-delay: -.66s;\n    }\n    > div:nth-child(8) {\n      animation-duration: .93s;\n      animation-delay: -.76s;\n    }\n    > div:nth-child(9) {\n      animation-duration: 1.24s;\n      animation-delay: -.76s;\n    }\n  ']);

var gridBeat = keyframes(_templateObject$12);
var props$11 = function props(_ref) {
  var color = _ref.color,
      width = _ref.width;

  var BallGridBeat = css(_templateObject2$11, color, width, width, width / 4.5, width / 4.5, width / 4.5 / 4, gridBeat);
  return {
    BallGridBeat: BallGridBeat
  };
};
var BallGridBeat = compose(pure, defaultProps({
  width: 34,
  color: '#fff',
  loading: false
}), withProps(props$11))(function (_ref2) {
  var center = _ref2.center,
      loading = _ref2.loading,
      BallGridBeat = _ref2.BallGridBeat;
  return React.createElement(
    'div',
    { className: cx('react-loading-wrap', defineProperty({}, flexCenter, center)) },
    loading ? React.createElement(
      'div',
      { className: BallGridBeat },
      React.createElement('div', null),
      React.createElement('div', null),
      React.createElement('div', null),
      React.createElement('div', null),
      React.createElement('div', null),
      React.createElement('div', null),
      React.createElement('div', null),
      React.createElement('div', null),
      React.createElement('div', null)
    ) : null
  );
});

var _templateObject$13 = taggedTemplateLiteral(['\n  0% {\n    opacity: 1;\n    transform: scale(1);\n  }\n  50% {\n    opacity: .35;\n    transform: scale(.45);\n  }\n  100% {\n    opacity: 1;\n    transform: scale(1);\n  }\n'], ['\n  0% {\n    opacity: 1;\n    transform: scale(1);\n  }\n  50% {\n    opacity: .35;\n    transform: scale(.45);\n  }\n  100% {\n    opacity: 1;\n    transform: scale(1);\n  }\n']);
var _templateObject2$12 = taggedTemplateLiteral(['\n    position: relative;\n    box-sizing: border-box;\n    display: block;\n    font-size: 0;\n    color: ', ';\n    width: ', 'px;\n    height: ', 'px;\n\n    > div {\n      display: inline-block;\n      float: none;\n      background-color: currentColor;\n      border: 0 solid currentColor;\n      width: ', 'px;\n      height: ', 'px;\n      margin: ', 'px;\n      border-radius: 100%;\n      animation-name: ', ';\n      animation-iteration-count: infinite;\n    }\n    > div:nth-child(1) {\n      animation-duration: .65s;\n      animation-delay: .03s;\n    }\n    > div:nth-child(2) {\n      animation-duration: 1.02s;\n      animation-delay: .09s;\n    }\n    > div:nth-child(3) {\n      animation-duration: 1.06s;\n      animation-delay: -.69s;\n    }\n    > div:nth-child(4) {\n      animation-duration: 1.5s;\n      animation-delay: -.41s;\n    }\n    > div:nth-child(5) {\n      animation-duration: 1.6s;\n      animation-delay: .04s;\n    }\n    > div:nth-child(6) {\n      animation-duration: .84s;\n      animation-delay: .07s;\n    }\n    > div:nth-child(7) {\n      animation-duration: .68s;\n      animation-delay: -.66s;\n    }\n    > div:nth-child(8) {\n      animation-duration: .93s;\n      animation-delay: -.76s;\n    }\n    > div:nth-child(9) {\n      animation-duration: 1.24s;\n      animation-delay: -.76s;\n    }\n  '], ['\n    position: relative;\n    box-sizing: border-box;\n    display: block;\n    font-size: 0;\n    color: ', ';\n    width: ', 'px;\n    height: ', 'px;\n\n    > div {\n      display: inline-block;\n      float: none;\n      background-color: currentColor;\n      border: 0 solid currentColor;\n      width: ', 'px;\n      height: ', 'px;\n      margin: ', 'px;\n      border-radius: 100%;\n      animation-name: ', ';\n      animation-iteration-count: infinite;\n    }\n    > div:nth-child(1) {\n      animation-duration: .65s;\n      animation-delay: .03s;\n    }\n    > div:nth-child(2) {\n      animation-duration: 1.02s;\n      animation-delay: .09s;\n    }\n    > div:nth-child(3) {\n      animation-duration: 1.06s;\n      animation-delay: -.69s;\n    }\n    > div:nth-child(4) {\n      animation-duration: 1.5s;\n      animation-delay: -.41s;\n    }\n    > div:nth-child(5) {\n      animation-duration: 1.6s;\n      animation-delay: .04s;\n    }\n    > div:nth-child(6) {\n      animation-duration: .84s;\n      animation-delay: .07s;\n    }\n    > div:nth-child(7) {\n      animation-duration: .68s;\n      animation-delay: -.66s;\n    }\n    > div:nth-child(8) {\n      animation-duration: .93s;\n      animation-delay: -.76s;\n    }\n    > div:nth-child(9) {\n      animation-duration: 1.24s;\n      animation-delay: -.76s;\n    }\n  ']);

var gridPulse = keyframes(_templateObject$13);
var props$12 = function props(_ref) {
  var color = _ref.color,
      width = _ref.width;

  var BallGridPulse = css(_templateObject2$12, color, width, width, width / 4.5, width / 4.5, width / 4.5 / 4, gridPulse);
  return {
    BallGridPulse: BallGridPulse
  };
};
var BallGridPulse = compose(pure, defaultProps({
  width: 36,
  color: '#fff',
  loading: false
}), withProps(props$12))(function (_ref2) {
  var center = _ref2.center,
      loading = _ref2.loading,
      BallGridPulse = _ref2.BallGridPulse;
  return React.createElement(
    'div',
    { className: cx('react-loading-wrap', defineProperty({}, flexCenter, center)) },
    loading ? React.createElement(
      'div',
      { className: BallGridPulse },
      React.createElement('div', null),
      React.createElement('div', null),
      React.createElement('div', null),
      React.createElement('div', null),
      React.createElement('div', null),
      React.createElement('div', null),
      React.createElement('div', null),
      React.createElement('div', null),
      React.createElement('div', null)
    ) : null
  );
});

var _templateObject$14 = taggedTemplateLiteral(['\n  25% {\n    transform: translateX(-100%);\n    animation-timing-function: ease-in;\n  }\n  50% {\n    transform: translateX(0%);\n  }\n'], ['\n  25% {\n    transform: translateX(-100%);\n    animation-timing-function: ease-in;\n  }\n  50% {\n    transform: translateX(0%);\n  }\n']);
var _templateObject2$13 = taggedTemplateLiteral(['\n  50% {\n    transform: translateX(0%);\n  }\n  75% {\n    transform: translateX(100%);\n    animation-timing-function: ease-in;\n  }\n  100% {\n    transform: translateX(0%);\n  }\n'], ['\n  50% {\n    transform: translateX(0%);\n  }\n  75% {\n    transform: translateX(100%);\n    animation-timing-function: ease-in;\n  }\n  100% {\n    transform: translateX(0%);\n  }\n']);
var _templateObject3$5 = taggedTemplateLiteral(['\n    position: relative;\n    box-sizing: border-box;\n    display: block;\n    font-size: 0;\n    color: ', ';\n    width: ', 'px;\n    height: ', 'px;\n\n    > div {\n      display: inline-block;\n      float: none;\n      background-color: currentColor;\n      border: 0 solid currentColor;\n      width: ', 'px;\n      height: ', 'px;\n      border-radius: 100%;\n    }\n    > div:first-child {\n      transform: translateX(0%);\n      animation: ', ' 1s 0s ease-out infinite;\n    }\n    > div:last-child {\n      transform: translateX(0%);\n      animation: ', ' 1s 0s ease-out infinite;\n    }\n  '], ['\n    position: relative;\n    box-sizing: border-box;\n    display: block;\n    font-size: 0;\n    color: ', ';\n    width: ', 'px;\n    height: ', 'px;\n\n    > div {\n      display: inline-block;\n      float: none;\n      background-color: currentColor;\n      border: 0 solid currentColor;\n      width: ', 'px;\n      height: ', 'px;\n      border-radius: 100%;\n    }\n    > div:first-child {\n      transform: translateX(0%);\n      animation: ', ' 1s 0s ease-out infinite;\n    }\n    > div:last-child {\n      transform: translateX(0%);\n      animation: ', ' 1s 0s ease-out infinite;\n    }\n  ']);

var left = keyframes(_templateObject$14);
var right = keyframes(_templateObject2$13);
var props$13 = function props(_ref) {
  var color = _ref.color,
      width = _ref.width;

  var BallNewtonCradle = css(_templateObject3$5, color, width, width / 4, width / 4, width / 4, left, right);
  return {
    BallNewtonCradle: BallNewtonCradle
  };
};
var BallNewtonCradle = compose(pure, defaultProps({
  width: 40,
  color: '#fff',
  loading: false
}), withProps(props$13))(function (_ref2) {
  var center = _ref2.center,
      loading = _ref2.loading,
      BallNewtonCradle = _ref2.BallNewtonCradle;
  return React.createElement(
    'div',
    { className: cx('react-loading-wrap', defineProperty({}, flexCenter, center)) },
    loading ? React.createElement(
      'div',
      { className: BallNewtonCradle },
      React.createElement('div', null),
      React.createElement('div', null),
      React.createElement('div', null),
      React.createElement('div', null)
    ) : null
  );
});

var _templateObject$15 = taggedTemplateLiteral(['\n  0%,\n  60%,\n  100% {\n    opacity: 1;\n    transform: scale(1);\n  }\n  30% {\n    opacity: .1;\n    transform: scale(.01);\n  }\n'], ['\n  0%,\n  60%,\n  100% {\n    opacity: 1;\n    transform: scale(1);\n  }\n  30% {\n    opacity: .1;\n    transform: scale(.01);\n  }\n']);
var _templateObject2$14 = taggedTemplateLiteral(['\n    position: relative;\n    box-sizing: border-box;\n    display: block;\n    font-size: 0;\n    color: ', ';\n    width: ', 'px;\n    height: ', 'px;\n\n    > div {\n      display: inline-block;\n      float: none;\n      background-color: currentColor;\n      border: 0 solid currentColor;\n      width: ', 'px;\n      height: ', 'px;\n      margin: ', 'px;\n      border-radius: 100%;\n      animation: ', ' 1s ease infinite;\n    }\n\n    > div:nth-child(1) {\n      animation-delay: -200ms;\n    }\n    > div:nth-child(2) {\n      animation-delay: -100ms;\n    }\n    > div:nth-child(3) {\n      animation-delay: 0ms;\n    }\n  '], ['\n    position: relative;\n    box-sizing: border-box;\n    display: block;\n    font-size: 0;\n    color: ', ';\n    width: ', 'px;\n    height: ', 'px;\n\n    > div {\n      display: inline-block;\n      float: none;\n      background-color: currentColor;\n      border: 0 solid currentColor;\n      width: ', 'px;\n      height: ', 'px;\n      margin: ', 'px;\n      border-radius: 100%;\n      animation: ', ' 1s ease infinite;\n    }\n\n    > div:nth-child(1) {\n      animation-delay: -200ms;\n    }\n    > div:nth-child(2) {\n      animation-delay: -100ms;\n    }\n    > div:nth-child(3) {\n      animation-delay: 0ms;\n    }\n  ']);

var scale$1 = keyframes(_templateObject$15);
var props$14 = function props(_ref) {
  var color = _ref.color,
      width = _ref.width;

  var sWidth = width / 3 / 1.8;
  var sMargin = (width / 3 - sWidth) / 2;
  var BallPulse = css(_templateObject2$14, color, width, width / 3, sWidth, sWidth, sMargin, scale$1);
  return {
    BallPulse: BallPulse
  };
};
var BallPulse = compose(pure, defaultProps({
  width: 54,
  color: '#fff',
  loading: false
}), withProps(props$14))(function (_ref2) {
  var center = _ref2.center,
      loading = _ref2.loading,
      BallPulse = _ref2.BallPulse;
  return React.createElement(
    'div',
    { className: cx('react-loading-wrap', defineProperty({}, flexCenter, center)) },
    loading ? React.createElement(
      'div',
      { className: BallPulse },
      React.createElement('div', null),
      React.createElement('div', null),
      React.createElement('div', null)
    ) : null
  );
});

var _templateObject$16 = taggedTemplateLiteral(['\n  0% {\n    opacity: 1;\n    transform: scale(1.1);\n  }\n  25% {\n    transform: translateY(-200%);\n  }\n  50% {\n    opacity: .35;\n    transform: scale(.3);\n  }\n  75% {\n    transform: translateY(200%);\n  }\n  100% {\n    opacity: 1;\n    transform: translateY(0);\n    transform: scale(1);\n  }\n'], ['\n  0% {\n    opacity: 1;\n    transform: scale(1.1);\n  }\n  25% {\n    transform: translateY(-200%);\n  }\n  50% {\n    opacity: .35;\n    transform: scale(.3);\n  }\n  75% {\n    transform: translateY(200%);\n  }\n  100% {\n    opacity: 1;\n    transform: translateY(0);\n    transform: scale(1);\n  }\n']);
var _templateObject2$15 = taggedTemplateLiteral(['\n0% {\n  opacity: .35;\n  transform: scale(.4);\n}\n25% {\n  transform: translateY(200%);\n}\n50% {\n  opacity: 1;\n  transform: scale(1.1);\n}\n75% {\n  transform: translateY(-200%);\n}\n100% {\n  opacity: .35;\n  transform: translateY(0);\n  transform: scale(.75);\n}\n'], ['\n0% {\n  opacity: .35;\n  transform: scale(.4);\n}\n25% {\n  transform: translateY(200%);\n}\n50% {\n  opacity: 1;\n  transform: scale(1.1);\n}\n75% {\n  transform: translateY(-200%);\n}\n100% {\n  opacity: .35;\n  transform: translateY(0);\n  transform: scale(.75);\n}\n']);
var _templateObject3$6 = taggedTemplateLiteral(['\n    position: relative;\n    box-sizing: border-box;\n    display: block;\n    font-size: 0;\n    color: ', ';\n    width: ', 'px;\n    height: ', 'px;\n\n    > div {\n      display: inline-block;\n      float: none;\n      background-color: currentColor;\n      border: 0 solid currentColor;\n      width: ', 'px;\n      height: ', 'px;\n      margin: ', 'px;\n      border-radius: 100%;\n      animation: ', ' 1s cubic-bezier(.15, .36, .9, .6) 0s infinite;\n    }\n    > div:nth-child(2n-1) {\n      animation-name: ', ';\n    }\n  '], ['\n    position: relative;\n    box-sizing: border-box;\n    display: block;\n    font-size: 0;\n    color: ', ';\n    width: ', 'px;\n    height: ', 'px;\n\n    > div {\n      display: inline-block;\n      float: none;\n      background-color: currentColor;\n      border: 0 solid currentColor;\n      width: ', 'px;\n      height: ', 'px;\n      margin: ', 'px;\n      border-radius: 100%;\n      animation: ', ' 1s cubic-bezier(.15, .36, .9, .6) 0s infinite;\n    }\n    > div:nth-child(2n-1) {\n      animation-name: ', ';\n    }\n  ']);

var anima = keyframes(_templateObject$16);
var odd = keyframes(_templateObject2$15);
var props$15 = function props(_ref) {
  var color = _ref.color,
      width = _ref.width;

  var sMargin = width / 5 / 7;
  var sWidth = width / 5 - sMargin * 2;
  var BallPulseRise = css(_templateObject3$6, color, width, width / 5, sWidth, sWidth, sMargin, anima, odd);
  return {
    BallPulseRise: BallPulseRise
  };
};
var BallPulseRise = compose(pure, defaultProps({
  width: 70,
  color: '#fff',
  loading: false
}), withProps(props$15))(function (_ref2) {
  var center = _ref2.center,
      loading = _ref2.loading,
      BallPulseRise = _ref2.BallPulseRise;
  return React.createElement(
    'div',
    { className: cx('react-loading-wrap', defineProperty({}, flexCenter, center)) },
    loading ? React.createElement(
      'div',
      { className: BallPulseRise },
      React.createElement('div', null),
      React.createElement('div', null),
      React.createElement('div', null),
      React.createElement('div', null),
      React.createElement('div', null)
    ) : null
  );
});

var _templateObject$17 = taggedTemplateLiteral(['\n  33% {\n    transform: translateY(100%);\n  }\n  66% {\n    transform: translateY(-100%);\n  }\n  100% {\n    transform: translateY(0);\n  }\n'], ['\n  33% {\n    transform: translateY(100%);\n  }\n  66% {\n    transform: translateY(-100%);\n  }\n  100% {\n    transform: translateY(0);\n  }\n']);
var _templateObject2$16 = taggedTemplateLiteral(['\n    position: relative;\n    box-sizing: border-box;\n    display: block;\n    font-size: 0;\n    color: ', ';\n    width: ', 'px;\n    height: ', 'px;\n\n    > div {\n      display: inline-block;\n      float: none;\n      background-color: currentColor;\n      border: 0 solid currentColor;\n      width: ', 'px;\n      height: ', 'px;\n      margin: ', 'px;\n      border-radius: 100%;\n      animation: ', ' .6s infinite ease-in-out;\n    }\n\n    > div:nth-child(1) {\n      animation-delay: -.14s;\n    }\n    > div:nth-child(2) {\n      animation-delay: -.07s;\n    }\n    > div:nth-child(3) {\n      animation-delay: 0s;\n    }\n  '], ['\n    position: relative;\n    box-sizing: border-box;\n    display: block;\n    font-size: 0;\n    color: ', ';\n    width: ', 'px;\n    height: ', 'px;\n\n    > div {\n      display: inline-block;\n      float: none;\n      background-color: currentColor;\n      border: 0 solid currentColor;\n      width: ', 'px;\n      height: ', 'px;\n      margin: ', 'px;\n      border-radius: 100%;\n      animation: ', ' .6s infinite ease-in-out;\n    }\n\n    > div:nth-child(1) {\n      animation-delay: -.14s;\n    }\n    > div:nth-child(2) {\n      animation-delay: -.07s;\n    }\n    > div:nth-child(3) {\n      animation-delay: 0s;\n    }\n  ']);

var sync = keyframes(_templateObject$17);
var props$16 = function props(_ref) {
  var color = _ref.color,
      width = _ref.width;

  var sMargin = width / 3 / 4.5;
  var sWidth = width / 3 - sMargin * 2;
  var BallPulseSync = css(_templateObject2$16, color, width, width / 3, sWidth, sWidth, sMargin, sync);
  return {
    BallPulseSync: BallPulseSync
  };
};
var BallPulseSync = compose(pure, defaultProps({
  width: 54,
  color: '#fff',
  loading: false
}), withProps(props$16))(function (_ref2) {
  var center = _ref2.center,
      loading = _ref2.loading,
      BallPulseSync = _ref2.BallPulseSync;
  return React.createElement(
    'div',
    { className: cx('react-loading-wrap', defineProperty({}, flexCenter, center)) },
    loading ? React.createElement(
      'div',
      { className: BallPulseSync },
      React.createElement('div', null),
      React.createElement('div', null),
      React.createElement('div', null)
    ) : null
  );
});

var _templateObject$18 = taggedTemplateLiteral(['\n  0% {\n    transform: rotate(0deg);\n  }\n  50% {\n    transform: rotate(180deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n'], ['\n  0% {\n    transform: rotate(0deg);\n  }\n  50% {\n    transform: rotate(180deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n']);
var _templateObject2$17 = taggedTemplateLiteral(['\n    position: relative;\n    box-sizing: border-box;\n    display: block;\n    font-size: 0;\n    color: ', ';\n    width: ', 'px;\n    height: ', 'px;\n\n    > div {\n      display: inline-block;\n      float: none;\n      background-color: currentColor;\n      border: 0 solid currentColor;\n      width: ', 'px;\n      height: ', 'px;\n      border-radius: 100%;\n      animation: ', ' 1s cubic-bezier(.7, -.13, .22, .86) infinite;\n    }\n    > div:before,\n    > div:after {\n      position: absolute;\n      width: inherit;\n      height: inherit;\n      margin: inherit;\n      content: "";\n      background: currentColor;\n      border-radius: inherit;\n      opacity: .8;\n    }\n    > div:before {\n      top: 0;\n      left: -150%;\n    }\n    > div:after {\n      top: 0;\n      left: 150%;\n    }\n  '], ['\n    position: relative;\n    box-sizing: border-box;\n    display: block;\n    font-size: 0;\n    color: ', ';\n    width: ', 'px;\n    height: ', 'px;\n\n    > div {\n      display: inline-block;\n      float: none;\n      background-color: currentColor;\n      border: 0 solid currentColor;\n      width: ', 'px;\n      height: ', 'px;\n      border-radius: 100%;\n      animation: ', ' 1s cubic-bezier(.7, -.13, .22, .86) infinite;\n    }\n    > div:before,\n    > div:after {\n      position: absolute;\n      width: inherit;\n      height: inherit;\n      margin: inherit;\n      content: "";\n      background: currentColor;\n      border-radius: inherit;\n      opacity: .8;\n    }\n    > div:before {\n      top: 0;\n      left: -150%;\n    }\n    > div:after {\n      top: 0;\n      left: 150%;\n    }\n  ']);

var rotate$5 = keyframes(_templateObject$18);
var props$17 = function props(_ref) {
  var color = _ref.color,
      width = _ref.width;

  var BallRotate = css(_templateObject2$17, color, width, width, width, width, rotate$5);
  return {
    BallRotate: BallRotate
  };
};
var BallRotate = compose(pure, defaultProps({
  width: 10,
  color: '#fff',
  loading: false
}), withProps(props$17))(function (_ref2) {
  var center = _ref2.center,
      loading = _ref2.loading,
      BallRotate = _ref2.BallRotate;
  return React.createElement(
    'div',
    { className: cx('react-loading-wrap', defineProperty({}, flexCenter, center)) },
    loading ? React.createElement(
      'div',
      { className: BallRotate },
      React.createElement('div', null)
    ) : null
  );
});

var _templateObject$19 = taggedTemplateLiteral(['\n  0%,\n  100% {\n    width: 100%;\n    height: 100%;\n    transform: translateY(0) translateX(500%);\n  }\n  80% {\n    transform: translateY(0) translateX(0);\n  }\n  85% {\n    width: 100%;\n    height: 100%;\n    transform: translateY(-125%) translateX(0);\n  }\n  90% {\n    width: 200%;\n    height: 75%;\n  }\n  95% {\n    width: 100%;\n    height: 100%;\n    transform: translateY(-100%) translateX(500%);\n  }\n'], ['\n  0%,\n  100% {\n    width: 100%;\n    height: 100%;\n    transform: translateY(0) translateX(500%);\n  }\n  80% {\n    transform: translateY(0) translateX(0);\n  }\n  85% {\n    width: 100%;\n    height: 100%;\n    transform: translateY(-125%) translateX(0);\n  }\n  90% {\n    width: 200%;\n    height: 75%;\n  }\n  95% {\n    width: 100%;\n    height: 100%;\n    transform: translateY(-100%) translateX(500%);\n  }\n']);
var _templateObject2$18 = taggedTemplateLiteral(['\n    position: relative;\n    box-sizing: border-box;\n    display: block;\n    font-size: 0;\n    color: ', ';\n    width: ', 'px;\n    height: ', 'px;\n\n    > div {\n      display: inline-block;\n      float: none;\n      background-color: currentColor;\n      border: 0 solid currentColor;\n      position: absolute;\n      width: 10px;\n      height: 10px;\n      margin-left: -25px;\n      border-radius: 100%;\n      animation: ', ' 2s linear infinite;\n    }\n\n    > div:nth-child(1) {\n      animation-delay: 0s;\n    }\n    > div:nth-child(2) {\n      animation-delay: -.4s;\n    }\n    > div:nth-child(3) {\n      animation-delay: -.8s;\n    }\n    > div:nth-child(4) {\n      animation-delay: -1.2s;\n    }\n    > div:nth-child(5) {\n      animation-delay: -1.6s;\n    }\n    > div:nth-child(6) {\n      animation-delay: -2s;\n    }\n    > div:nth-child(7) {\n      animation-delay: -2.4s;\n    }\n    > div:nth-child(8) {\n      animation-delay: -2.8s;\n    }\n    > div:nth-child(9) {\n      animation-delay: -3.2s;\n    }\n    > div:nth-child(10) {\n      animation-delay: -3.6s;\n    }\n  '], ['\n    position: relative;\n    box-sizing: border-box;\n    display: block;\n    font-size: 0;\n    color: ', ';\n    width: ', 'px;\n    height: ', 'px;\n\n    > div {\n      display: inline-block;\n      float: none;\n      background-color: currentColor;\n      border: 0 solid currentColor;\n      position: absolute;\n      width: 10px;\n      height: 10px;\n      margin-left: -25px;\n      border-radius: 100%;\n      animation: ', ' 2s linear infinite;\n    }\n\n    > div:nth-child(1) {\n      animation-delay: 0s;\n    }\n    > div:nth-child(2) {\n      animation-delay: -.4s;\n    }\n    > div:nth-child(3) {\n      animation-delay: -.8s;\n    }\n    > div:nth-child(4) {\n      animation-delay: -1.2s;\n    }\n    > div:nth-child(5) {\n      animation-delay: -1.6s;\n    }\n    > div:nth-child(6) {\n      animation-delay: -2s;\n    }\n    > div:nth-child(7) {\n      animation-delay: -2.4s;\n    }\n    > div:nth-child(8) {\n      animation-delay: -2.8s;\n    }\n    > div:nth-child(9) {\n      animation-delay: -3.2s;\n    }\n    > div:nth-child(10) {\n      animation-delay: -3.6s;\n    }\n  ']);

var dots = keyframes(_templateObject$19);
var props$18 = function props(_ref) {
  var color = _ref.color,
      width = _ref.width;

  var BallRunningDots = css(_templateObject2$18, color, width, width, dots);
  return {
    BallRunningDots: BallRunningDots
  };
};
var BallRunningDots = compose(pure, defaultProps({
  width: 10,
  color: '#fff',
  loading: false
}), withProps(props$18))(function (_ref2) {
  var center = _ref2.center,
      loading = _ref2.loading,
      BallRunningDots = _ref2.BallRunningDots;
  return React.createElement(
    'div',
    { className: cx('react-loading-wrap', defineProperty({}, flexCenter, center)) },
    loading ? React.createElement(
      'div',
      { className: BallRunningDots },
      React.createElement('div', null),
      React.createElement('div', null),
      React.createElement('div', null),
      React.createElement('div', null),
      React.createElement('div', null)
    ) : null
  );
});

var _templateObject$20 = taggedTemplateLiteral(['\n  0% {\n    opacity: 1;\n    transform: scale(0);\n  }\n  100% {\n    opacity: 0;\n    transform: scale(1);\n  }\n'], ['\n  0% {\n    opacity: 1;\n    transform: scale(0);\n  }\n  100% {\n    opacity: 0;\n    transform: scale(1);\n  }\n']);
var _templateObject2$19 = taggedTemplateLiteral(['\n    position: relative;\n    box-sizing: border-box;\n    display: block;\n    font-size: 0;\n    color: ', ';\n    width: ', 'px;\n    height: ', 'px;\n\n    > div {\n      display: inline-block;\n      float: none;\n      background-color: currentColor;\n      border: 0 solid currentColor;\n      width: ', 'px;\n      height: ', 'px;\n      border-radius: 100%;\n      opacity: 0;\n      animation: ', ' 1s 0s ease-in-out infinite;\n    }\n  '], ['\n    position: relative;\n    box-sizing: border-box;\n    display: block;\n    font-size: 0;\n    color: ', ';\n    width: ', 'px;\n    height: ', 'px;\n\n    > div {\n      display: inline-block;\n      float: none;\n      background-color: currentColor;\n      border: 0 solid currentColor;\n      width: ', 'px;\n      height: ', 'px;\n      border-radius: 100%;\n      opacity: 0;\n      animation: ', ' 1s 0s ease-in-out infinite;\n    }\n  ']);

var scale$2 = keyframes(_templateObject$20);
var props$19 = function props(_ref) {
  var color = _ref.color,
      width = _ref.width;

  var BallScale = css(_templateObject2$19, color, width, width, width, width, scale$2);
  return {
    BallScale: BallScale
  };
};
var BallScale = compose(pure, defaultProps({
  width: 32,
  color: '#fff',
  loading: false
}), withProps(props$19))(function (_ref2) {
  var center = _ref2.center,
      loading = _ref2.loading,
      BallScale = _ref2.BallScale;
  return React.createElement(
    'div',
    { className: cx('react-loading-wrap', defineProperty({}, flexCenter, center)) },
    loading ? React.createElement(
      'div',
      { className: BallScale },
      React.createElement('div', null)
    ) : null
  );
});

var _templateObject$21 = taggedTemplateLiteral(['\n  0% {\n    opacity: 0;\n    transform: scale(0);\n  }\n  5% {\n    opacity: .75;\n  }\n  100% {\n    opacity: 0;\n    transform: scale(1);\n  }\n'], ['\n  0% {\n    opacity: 0;\n    transform: scale(0);\n  }\n  5% {\n    opacity: .75;\n  }\n  100% {\n    opacity: 0;\n    transform: scale(1);\n  }\n']);
var _templateObject2$20 = taggedTemplateLiteral(['\n    position: relative;\n    box-sizing: border-box;\n    display: block;\n    font-size: 0;\n    color: ', ';\n    width: ', 'px;\n    height: ', 'px;\n\n    > div {\n      display: inline-block;\n      float: none;\n      background-color: currentColor;\n      border: 0 solid currentColor;\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: ', 'px;\n      height: ', 'px;\n      border-radius: 100%;\n      opacity: 0;\n      animation: ', ' 1s 0s linear infinite;\n    }\n    > div:nth-child(2) {\n      animation-delay: .2s;\n    }\n    > div:nth-child(3) {\n      animation-delay: .4s;\n    }\n  '], ['\n    position: relative;\n    box-sizing: border-box;\n    display: block;\n    font-size: 0;\n    color: ', ';\n    width: ', 'px;\n    height: ', 'px;\n\n    > div {\n      display: inline-block;\n      float: none;\n      background-color: currentColor;\n      border: 0 solid currentColor;\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: ', 'px;\n      height: ', 'px;\n      border-radius: 100%;\n      opacity: 0;\n      animation: ', ' 1s 0s linear infinite;\n    }\n    > div:nth-child(2) {\n      animation-delay: .2s;\n    }\n    > div:nth-child(3) {\n      animation-delay: .4s;\n    }\n  ']);

var scale$3 = keyframes(_templateObject$21);
var props$20 = function props(_ref) {
  var color = _ref.color,
      width = _ref.width;

  var BallScaleMultiple = css(_templateObject2$20, color, width, width, width, width, scale$3);
  return {
    BallScaleMultiple: BallScaleMultiple
  };
};
var BallScaleMultiple = compose(pure, defaultProps({
  width: 32,
  color: '#fff',
  loading: false
}), withProps(props$20))(function (_ref2) {
  var center = _ref2.center,
      loading = _ref2.loading,
      BallScaleMultiple = _ref2.BallScaleMultiple;
  return React.createElement(
    'div',
    { className: cx('react-loading-wrap', defineProperty({}, flexCenter, center)) },
    loading ? React.createElement(
      'div',
      { className: BallScaleMultiple },
      React.createElement('div', null),
      React.createElement('div', null),
      React.createElement('div', null)
    ) : null
  );
});

var _templateObject$22 = taggedTemplateLiteral(['\n  0%,\n  100% {\n    transform: scale(0);\n  }\n  50% {\n    transform: scale(1);\n  }\n'], ['\n  0%,\n  100% {\n    transform: scale(0);\n  }\n  50% {\n    transform: scale(1);\n  }\n']);
var _templateObject2$21 = taggedTemplateLiteral(['\n    position: relative;\n    box-sizing: border-box;\n    display: block;\n    font-size: 0;\n    color: ', ';\n    width: ', 'px;\n    height: ', 'px;\n\n    > div {\n      display: inline-block;\n      float: none;\n      background-color: currentColor;\n      border: 0 solid currentColor;\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: ', 'px;\n      height: ', 'px;\n      border-radius: 100%;\n      opacity: .5;\n      animation: ', ' 2s infinite ease-in-out;\n    }\n    > div:last-child {\n      animation-delay: -1.0s;\n    }\n  '], ['\n    position: relative;\n    box-sizing: border-box;\n    display: block;\n    font-size: 0;\n    color: ', ';\n    width: ', 'px;\n    height: ', 'px;\n\n    > div {\n      display: inline-block;\n      float: none;\n      background-color: currentColor;\n      border: 0 solid currentColor;\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: ', 'px;\n      height: ', 'px;\n      border-radius: 100%;\n      opacity: .5;\n      animation: ', ' 2s infinite ease-in-out;\n    }\n    > div:last-child {\n      animation-delay: -1.0s;\n    }\n  ']);

var scale$4 = keyframes(_templateObject$22);
var props$21 = function props(_ref) {
  var color = _ref.color,
      width = _ref.width;

  var BallScalePulse = css(_templateObject2$21, color, width, width, width, width, scale$4);
  return {
    BallScalePulse: BallScalePulse
  };
};
var BallScalePulse = compose(pure, defaultProps({
  width: 32,
  color: '#fff',
  loading: false
}), withProps(props$21))(function (_ref2) {
  var center = _ref2.center,
      loading = _ref2.loading,
      BallScalePulse = _ref2.BallScalePulse;
  return React.createElement(
    'div',
    { className: cx('react-loading-wrap', defineProperty({}, flexCenter, center)) },
    loading ? React.createElement(
      'div',
      { className: BallScalePulse },
      React.createElement('div', null),
      React.createElement('div', null)
    ) : null
  );
});

var _templateObject$23 = taggedTemplateLiteral(['\n  0% {\n    opacity: 1;\n    transform: scale(.1);\n  }\n  70% {\n    opacity: .65;\n    transform: scale(1);\n  }\n  100% {\n    opacity: 0;\n  }\n'], ['\n  0% {\n    opacity: 1;\n    transform: scale(.1);\n  }\n  70% {\n    opacity: .65;\n    transform: scale(1);\n  }\n  100% {\n    opacity: 0;\n  }\n']);
var _templateObject2$22 = taggedTemplateLiteral(['\n    position: relative;\n    box-sizing: border-box;\n    display: block;\n    font-size: 0;\n    color: ', ';\n    width: ', 'px;\n    height: ', 'px;\n\n    > div {\n      position: relative;\n      box-sizing: border-box;\n      display: inline-block;\n      float: none;\n      background-color: currentColor;\n      border: 0 solid currentColor;\n      width: ', 'px;\n      height: ', 'px;\n      background: transparent;\n      border-width: 2px;\n      border-radius: 100%;\n      opacity: 0;\n      animation: ', ' 1s 0s infinite cubic-bezier(.21, .53, .56, .8);\n    }\n  '], ['\n    position: relative;\n    box-sizing: border-box;\n    display: block;\n    font-size: 0;\n    color: ', ';\n    width: ', 'px;\n    height: ', 'px;\n\n    > div {\n      position: relative;\n      box-sizing: border-box;\n      display: inline-block;\n      float: none;\n      background-color: currentColor;\n      border: 0 solid currentColor;\n      width: ', 'px;\n      height: ', 'px;\n      background: transparent;\n      border-width: 2px;\n      border-radius: 100%;\n      opacity: 0;\n      animation: ', ' 1s 0s infinite cubic-bezier(.21, .53, .56, .8);\n    }\n  ']);

var scale$5 = keyframes(_templateObject$23);
var props$22 = function props(_ref) {
  var color = _ref.color,
      width = _ref.width;

  var BallScaleRipple = css(_templateObject2$22, color, width, width, width, width, scale$5);
  return {
    BallScaleRipple: BallScaleRipple
  };
};
var BallScaleRipple = compose(pure, defaultProps({
  width: 32,
  color: '#fff',
  loading: false
}), withProps(props$22))(function (_ref2) {
  var center = _ref2.center,
      loading = _ref2.loading,
      BallScaleRipple = _ref2.BallScaleRipple;
  return React.createElement(
    'div',
    { className: cx('react-loading-wrap', defineProperty({}, flexCenter, center)) },
    loading ? React.createElement(
      'div',
      { className: BallScaleRipple },
      React.createElement('div', null)
    ) : null
  );
});

var _templateObject$24 = taggedTemplateLiteral(['\n  0% {\n    opacity: 1;\n    transform: scale(.1);\n  }\n  70% {\n    opacity: .5;\n    transform: scale(1);\n  }\n  95% {\n    opacity: 0;\n  }\n'], ['\n  0% {\n    opacity: 1;\n    transform: scale(.1);\n  }\n  70% {\n    opacity: .5;\n    transform: scale(1);\n  }\n  95% {\n    opacity: 0;\n  }\n']);
var _templateObject2$23 = taggedTemplateLiteral(['\n    position: relative;\n    box-sizing: border-box;\n    display: block;\n    font-size: 0;\n    color: ', ';\n    width: ', 'px;\n    height: ', 'px;\n\n    > div {\n      display: inline-block;\n      float: none;\n      background-color: currentColor;\n      border: 0 solid currentColor;\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: ', 'px;\n      height: ', 'px;\n      background: transparent;\n      border-width: 2px;\n      border-radius: 100%;\n      opacity: 0;\n      animation: ', ' 1.25s 0s infinite cubic-bezier(.21, .53, .56, .8);\n    }\n    > div:nth-child(1) {\n      animation-delay: 0s;\n    }\n    > div:nth-child(2) {\n      animation-delay: .25s;\n    }\n    > div:nth-child(3) {\n      animation-delay: .5s;\n    }\n  '], ['\n    position: relative;\n    box-sizing: border-box;\n    display: block;\n    font-size: 0;\n    color: ', ';\n    width: ', 'px;\n    height: ', 'px;\n\n    > div {\n      display: inline-block;\n      float: none;\n      background-color: currentColor;\n      border: 0 solid currentColor;\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: ', 'px;\n      height: ', 'px;\n      background: transparent;\n      border-width: 2px;\n      border-radius: 100%;\n      opacity: 0;\n      animation: ', ' 1.25s 0s infinite cubic-bezier(.21, .53, .56, .8);\n    }\n    > div:nth-child(1) {\n      animation-delay: 0s;\n    }\n    > div:nth-child(2) {\n      animation-delay: .25s;\n    }\n    > div:nth-child(3) {\n      animation-delay: .5s;\n    }\n  ']);

var scale$6 = keyframes(_templateObject$24);
var props$23 = function props(_ref) {
  var color = _ref.color,
      width = _ref.width;

  var BallScaleRippleMultiple = css(_templateObject2$23, color, width, width, width, width, scale$6);
  return {
    BallScaleRippleMultiple: BallScaleRippleMultiple
  };
};
var BallScaleRippleMultiple = compose(pure, defaultProps({
  width: 32,
  color: '#fff',
  loading: false
}), withProps(props$23))(function (_ref2) {
  var center = _ref2.center,
      loading = _ref2.loading,
      BallScaleRippleMultiple = _ref2.BallScaleRippleMultiple;
  return React.createElement(
    'div',
    { className: cx('react-loading-wrap', defineProperty({}, flexCenter, center)) },
    loading ? React.createElement(
      'div',
      { className: BallScaleRippleMultiple },
      React.createElement('div', null),
      React.createElement('div', null),
      React.createElement('div', null)
    ) : null
  );
});

var _templateObject$25 = taggedTemplateLiteral(['\n  0%,\n  100% {\n    opacity: 1;\n    transform: scale(1);\n  }\n  20% {\n      opacity: 1;\n  }\n  80% {\n    opacity: 0;\n    transform: scale(0);\n  }\n'], ['\n  0%,\n  100% {\n    opacity: 1;\n    transform: scale(1);\n  }\n  20% {\n      opacity: 1;\n  }\n  80% {\n    opacity: 0;\n    transform: scale(0);\n  }\n']);
var _templateObject2$24 = taggedTemplateLiteral(['\n    position: relative;\n    box-sizing: border-box;\n    display: block;\n    font-size: 0;\n    color: ', ';\n    width: ', 'px;\n    height: ', 'px;\n\n    > div {\n      position: relative;\n      box-sizing: border-box;\n      display: inline-block;\n      float: none;\n      background-color: currentColor;\n      border: 0 solid currentColor;\n      position: absolute;\n      top: 50%;\n      left: 50%;\n      width: ', 'px;\n      height: ', 'px;\n      margin-top: -', 'px;\n      margin-left: -', 'px;\n      border-radius: 100%;\n      animation: ', ' 1s infinite ease-in-out;\n    }\n\n    > div:nth-child(1) {\n      top: 5%;\n      left: 50%;\n      animation-delay: -1.125s;\n    }\n    > div:nth-child(2) {\n      top: 18.1801948466%;\n      left: 81.8198051534%;\n      animation-delay: -1.25s;\n    }\n    > div:nth-child(3) {\n      top: 50%;\n      left: 95%;\n      animation-delay: -1.375s;\n    }\n    > div:nth-child(4) {\n      top: 81.8198051534%;\n      left: 81.8198051534%;\n      animation-delay: -1.5s;\n    }\n    > div:nth-child(5) {\n      top: 94.9999999966%;\n      left: 50.0000000005%;\n      animation-delay: -1.625s;\n    }\n    > div:nth-child(6) {\n      top: 81.8198046966%;\n      left: 18.1801949248%;\n      animation-delay: -1.75s;\n    }\n    > div:nth-child(7) {\n      top: 49.9999750815%;\n      left: 5.0000051215%;\n      animation-delay: -1.875s;\n    }\n    > div:nth-child(8) {\n      top: 18.179464974%;\n      left: 18.1803700518%;\n      animation-delay: -2s;\n    }\n  '], ['\n    position: relative;\n    box-sizing: border-box;\n    display: block;\n    font-size: 0;\n    color: ', ';\n    width: ', 'px;\n    height: ', 'px;\n\n    > div {\n      position: relative;\n      box-sizing: border-box;\n      display: inline-block;\n      float: none;\n      background-color: currentColor;\n      border: 0 solid currentColor;\n      position: absolute;\n      top: 50%;\n      left: 50%;\n      width: ', 'px;\n      height: ', 'px;\n      margin-top: -', 'px;\n      margin-left: -', 'px;\n      border-radius: 100%;\n      animation: ', ' 1s infinite ease-in-out;\n    }\n\n    > div:nth-child(1) {\n      top: 5%;\n      left: 50%;\n      animation-delay: -1.125s;\n    }\n    > div:nth-child(2) {\n      top: 18.1801948466%;\n      left: 81.8198051534%;\n      animation-delay: -1.25s;\n    }\n    > div:nth-child(3) {\n      top: 50%;\n      left: 95%;\n      animation-delay: -1.375s;\n    }\n    > div:nth-child(4) {\n      top: 81.8198051534%;\n      left: 81.8198051534%;\n      animation-delay: -1.5s;\n    }\n    > div:nth-child(5) {\n      top: 94.9999999966%;\n      left: 50.0000000005%;\n      animation-delay: -1.625s;\n    }\n    > div:nth-child(6) {\n      top: 81.8198046966%;\n      left: 18.1801949248%;\n      animation-delay: -1.75s;\n    }\n    > div:nth-child(7) {\n      top: 49.9999750815%;\n      left: 5.0000051215%;\n      animation-delay: -1.875s;\n    }\n    > div:nth-child(8) {\n      top: 18.179464974%;\n      left: 18.1803700518%;\n      animation-delay: -2s;\n    }\n  ']);

var spin = keyframes(_templateObject$25);
var props$24 = function props(_ref) {
  var color = _ref.color,
      width = _ref.width;

  var BallSpin = css(_templateObject2$24, color, width, width, width / 4, width / 4, width / 4 / 2, width / 4 / 2, spin);
  return {
    BallSpin: BallSpin
  };
};
var BallSpin = compose(pure, defaultProps({
  width: 32,
  color: '#fff',
  loading: false
}), withProps(props$24))(function (_ref2) {
  var center = _ref2.center,
      loading = _ref2.loading,
      BallSpin = _ref2.BallSpin;
  return React.createElement(
    'div',
    { className: cx('react-loading-wrap', defineProperty({}, flexCenter, center)) },
    loading ? React.createElement(
      'div',
      { className: BallSpin },
      React.createElement('div', null),
      React.createElement('div', null),
      React.createElement('div', null),
      React.createElement('div', null),
      React.createElement('div', null),
      React.createElement('div', null),
      React.createElement('div', null),
      React.createElement('div', null)
    ) : null
  );
});

var _templateObject$26 = taggedTemplateLiteral(['\n  0%,\n  100% {\n    opacity: 1;\n    transform: scale(1);\n  }\n  20% {\n      opacity: 1;\n  }\n  80% {\n    opacity: 0;\n    transform: scale(0);\n  }\n'], ['\n  0%,\n  100% {\n    opacity: 1;\n    transform: scale(1);\n  }\n  20% {\n      opacity: 1;\n  }\n  80% {\n    opacity: 0;\n    transform: scale(0);\n  }\n']);
var _templateObject2$25 = taggedTemplateLiteral(['\n    position: relative;\n    box-sizing: border-box;\n    display: block;\n    font-size: 0;\n    color: ', ';\n    width: ', 'px;\n    height: ', 'px;\n\n    > div {\n      box-sizing: border-box;\n      display: inline-block;\n      float: none;\n      background-color: currentColor;\n      border: 0 solid currentColor;\n      position: absolute;\n      top: 50%;\n      left: 50%;\n      width: ', 'px;\n      height: ', 'px;\n      margin-top: -', 'px;\n      margin-left: -', 'px;\n      border-radius: 100%;\n      animation: ', ' 1s infinite ease-in-out;\n    }\n    > div:nth-child(1) {\n      top: 5%;\n      left: 50%;\n      animation-delay: -.875s;\n    }\n    > div:nth-child(2) {\n      top: 18.1801948466%;\n      left: 81.8198051534%;\n      animation-delay: -.75s;\n    }\n    > div:nth-child(3) {\n      top: 50%;\n      left: 95%;\n      animation-delay: -.625s;\n    }\n    > div:nth-child(4) {\n      top: 81.8198051534%;\n      left: 81.8198051534%;\n      animation-delay: -.5s;\n    }\n    > div:nth-child(5) {\n      top: 94.9999999966%;\n      left: 50.0000000005%;\n      animation-delay: -.375s;\n    }\n    > div:nth-child(6) {\n      top: 81.8198046966%;\n      left: 18.1801949248%;\n      animation-delay: -.25s;\n    }\n    > div:nth-child(7) {\n      top: 49.9999750815%;\n      left: 5.0000051215%;\n      animation-delay: -.125s;\n    }\n    > div:nth-child(8) {\n      top: 18.179464974%;\n      left: 18.1803700518%;\n      animation-delay: 0s;\n    }\n  '], ['\n    position: relative;\n    box-sizing: border-box;\n    display: block;\n    font-size: 0;\n    color: ', ';\n    width: ', 'px;\n    height: ', 'px;\n\n    > div {\n      box-sizing: border-box;\n      display: inline-block;\n      float: none;\n      background-color: currentColor;\n      border: 0 solid currentColor;\n      position: absolute;\n      top: 50%;\n      left: 50%;\n      width: ', 'px;\n      height: ', 'px;\n      margin-top: -', 'px;\n      margin-left: -', 'px;\n      border-radius: 100%;\n      animation: ', ' 1s infinite ease-in-out;\n    }\n    > div:nth-child(1) {\n      top: 5%;\n      left: 50%;\n      animation-delay: -.875s;\n    }\n    > div:nth-child(2) {\n      top: 18.1801948466%;\n      left: 81.8198051534%;\n      animation-delay: -.75s;\n    }\n    > div:nth-child(3) {\n      top: 50%;\n      left: 95%;\n      animation-delay: -.625s;\n    }\n    > div:nth-child(4) {\n      top: 81.8198051534%;\n      left: 81.8198051534%;\n      animation-delay: -.5s;\n    }\n    > div:nth-child(5) {\n      top: 94.9999999966%;\n      left: 50.0000000005%;\n      animation-delay: -.375s;\n    }\n    > div:nth-child(6) {\n      top: 81.8198046966%;\n      left: 18.1801949248%;\n      animation-delay: -.25s;\n    }\n    > div:nth-child(7) {\n      top: 49.9999750815%;\n      left: 5.0000051215%;\n      animation-delay: -.125s;\n    }\n    > div:nth-child(8) {\n      top: 18.179464974%;\n      left: 18.1803700518%;\n      animation-delay: 0s;\n    }\n  ']);

var spin$1 = keyframes(_templateObject$26);
var props$25 = function props(_ref) {
  var color = _ref.color,
      width = _ref.width;

  var BallSpinClockWise = css(_templateObject2$25, color, width, width, width / 4, width / 4, width / 4 / 2, width / 4 / 2, spin$1);
  return {
    BallSpinClockWise: BallSpinClockWise
  };
};
var BallSpinClockWise = compose(pure, defaultProps({
  width: 32,
  color: '#fff',
  loading: false
}), withProps(props$25))(function (_ref2) {
  var center = _ref2.center,
      loading = _ref2.loading,
      BallSpinClockWise = _ref2.BallSpinClockWise;
  return React.createElement(
    'div',
    { className: cx('react-loading-wrap', defineProperty({}, flexCenter, center)) },
    loading ? React.createElement(
      'div',
      { className: BallSpinClockWise },
      React.createElement('div', null),
      React.createElement('div', null),
      React.createElement('div', null),
      React.createElement('div', null),
      React.createElement('div', null),
      React.createElement('div', null),
      React.createElement('div', null),
      React.createElement('div', null)
    ) : null
  );
});

export { Ball8bits, BallClipRotate, BallClipRotateMultiple, BallClipRotatePulse, BallAtom, BallBeat, BallCircus, BallClimbingDot, BallElasticDots, BallFall, BallFussion, BallGridBeat, BallGridPulse, BallNewtonCradle, BallPulse, BallPulseRise, BallPulseSync, BallRotate, BallRunningDots, BallScale, BallScaleMultiple, BallScalePulse, BallScaleRipple, BallScaleRippleMultiple, BallSpin, BallSpinClockWise };
